var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Thu Jul  4 15:40:00 2024\n By \nCopyright 2023 The Afacad Project Authors (https://github.com/Dicotype/Afacad)\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "AfacadFlux-Regular",
    horizAdvX: 480
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Afacad Flux",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1440,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 1152,
    descent: -288,
    xHeight: 600,
    capHeight: 900,
    bbox: "-294 -433 1578 1368",
    underlineThickness: 90,
    underlinePosition: -180,
    unicodeRange: "U+000D-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 720,
    d: "M96 -300v1260h528v-1260h-528z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 760,
    d: "M166 0v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94 -13.5t79 -39.5l-28 -113q-25 32 -62.5 51t-83.5 19q-67 0 -112.5 -42t-45.5 -123v-111h393v-600h-108v510h-282v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 760,
    d: "M166 0v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-960h-108v510h-282v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 840,
    d: "M166 0v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h149v-90h-146v-510h-108v510h-282v-510h-108zM271 600 h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 1150,
    d: "M166 0v510h-136v90h139v103q0 86 38.5 146t101 91.5t135.5 31.5q55 0 103.5 -15.5t90.5 -49.5q37 32 83.5 48.5t98.5 16.5q50 0 94 -13.5t79 -39.5l-28 -113q-25 33 -62.5 54.5t-83.5 21.5q-67 0 -112.5 -42t-45.5 -123v-117h393v-600h-108v510h-282v-510h-108v510h-282 v-510h-108zM271 600h288v121q0 31 5.5 57t15.5 49q-26 25 -60.5 40t-75.5 15q-50 0 -89 -21t-61.5 -61t-22.5 -96v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 1150,
    d: "M166 0v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-960h-108v510h-282v-510h-108v510h-282 v-510h-108zM271 600h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 720,
    d: "M96 -300v1260h528v-1260h-528z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 800
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "CR",
    unicode: "\r",
    horizAdvX: 800
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    d: "M192 300l-6 600h108l-6 -600h-96zM240 -12q-21 0 -38 10t-27 27t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 540,
    d: "M102 570l-36 330h138l-36 -330h-66zM372 570l-36 330h138l-36 -330h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 750,
    d: "M110 0l39 234h-112l14 84h112l44 264h-116l14 84h116l39 234h96l-39 -234h186l39 234h96l-39 -234h114l-14 -84h-114l-44 -264h118l-14 -84h-118l-39 -234h-96l39 234h-186l-39 -234h-96zM254 314h194l46 272h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 750,
    d: "M348 -120v108q-74 4 -134 35.5t-96 74.5l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 62 26 111t72.5 80.5t108.5 39.5v81h84v-81q57 -7 101 -29.5t70 -45.5 l-33 -138q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -66 -27 -119.5t-75 -89.5t-111 -49v-115h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1080,
    d: "M240 408q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 488q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26zM186 0l618 900h90l-618 -900h-90zM840 -12q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM840 68q37 0 59 26 t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 800,
    d: "M381 -12q-86 0 -153 35.5t-105.5 99t-38.5 145.5q0 70 27.5 118.5t66 80.5t70.5 50l-20 26q-25 33 -45.5 71.5t-20.5 90.5q0 59 28 105.5t75.5 74t105.5 27.5t106 -27.5t76.5 -74t28.5 -104.5q0 -62 -29 -102.5t-64.5 -63t-55.5 -33.5l-33 -17l209 -288q32 38 51.5 84 t23.5 95l80 -110q-16 -43 -41 -82.5t-58 -72.5l85 -116h-128l-41 55q-45 -34 -96 -50.5t-104 -16.5zM387 88q38 0 73.5 12t67.5 31l-224 311q-21 -12 -46 -33.5t-43.5 -55t-18.5 -81.5q0 -49 22.5 -91t65 -67.5t103.5 -25.5zM345 569l41 21q13 7 34 21t37.5 39t16.5 61 q0 30 -13.5 53.5t-36.5 37.5t-53 14q-29 0 -52 -14t-36 -37t-13 -51t14.5 -52.5t33.5 -53.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 270,
    d: "M102 570l-36 330h138l-36 -330h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    d: "M269 -180q-51 84 -87 176t-55 191t-19 203t19 203t55 191.5t87 175.5h121q-55 -80 -94 -171.5t-59.5 -191.5t-20.5 -207t20.5 -207t59.5 -191t94 -172h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    d: "M84 -180q56 81 94.5 172t59 191t20.5 207t-20.5 207t-59 191.5t-94.5 171.5h121q51 -83 87 -175.5t55 -191.5t19 -203t-19 -203t-55 -191t-87 -176h-121z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 600,
    d: "M189 407l-77 57l132 160l-202 52l30 91l193 -76l-13 209h96l-13 -209l193 76l30 -91l-202 -52l132 -160l-77 -57l-111 175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 750,
    d: "M327 135v270h-267v90h267v270h96v-270h267v-90h-267v-270h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 270,
    d: "M6 -150q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 360,
    d: "M30 252v96h300v-96h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 270,
    d: "M135 -12q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    d: "M-1 -180l380 1140h102l-380 -1140h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 750,
    d: "M375 -12q-79 0 -138 39.5t-98.5 106t-59 149t-19.5 167.5t19.5 167.5t59 149t98.5 106t138 39.5t138 -39.5t98.5 -106t59 -149t19.5 -167.5t-19.5 -167.5t-59 -149t-98.5 -106t-138 -39.5zM375 90q53 0 91 32t62 85t36 116.5t12 126.5t-12 126.5t-36 116.5t-62 85t-91 32 q-52 0 -90.5 -32t-62.5 -85t-36 -116.5t-12 -126.5t12 -126.5t36 -116.5t62.5 -85t90.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 750,
    d: "M162 0v90h208v668l-208 -106v108l316 160h2v-830h168v-90h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 750,
    d: "M119 0v2l361 535q26 38 35 66t9 52q0 43 -21 78t-57 56t-80 21t-79.5 -21t-56.5 -56t-21 -78q0 -34 15 -65t46 -56h-137q-32 61 -32 121q0 54 21 101t57.5 82t84.5 54.5t103 19.5q54 0 102 -19.5t84.5 -54.5t57.5 -82t21 -101q0 -28 -6 -56t-20 -57t-37 -63l-260 -377 h340v-102h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 750,
    d: "M342 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 103.5 27.5t73.5 73.5t27 103q0 56 -27.5 102.5t-73.5 74t-103 27.5q-28 0 -52 -6.5t-43 -17.5l-1 1l170 329h-278v96h444v-2l-169 -313q50 -10 94 -35.5t77 -64t51.5 -87 t18.5 -104.5q0 -64 -24.5 -120t-67 -97.5t-99 -65t-121.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 750,
    d: "M456 0v242h-432v2l337 656h120l-292 -562h270v202l102 54v-256h135v-96h-132v-242h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 750,
    d: "M342 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q56 0 102.5 27.5t74 73.5t27.5 102t-28 102t-74.5 73.5t-104.5 27.5q-50 0 -93.5 -22.5t-69.5 -60.5h-2v487h406v-102h-308v-222q20 9 41.5 12.5t41.5 3.5q61 0 115 -22.5t95.5 -63 t65 -95t23.5 -118.5t-24.5 -119.5t-68 -97.5t-100 -65t-119.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 750,
    d: "M381 -12q-66 0 -123 23t-100.5 65t-67.5 97.5t-24 119.5q0 39 10 76.5t27 70.5l241 460h124l-186 -343q28 22 57 29.5t59 7.5q62 0 115.5 -22.5t95 -63t64.5 -95t23 -119.5t-24 -120.5t-67.5 -97.5t-100.5 -65t-123 -23zM382 90q58 0 104.5 27.5t74 74t27.5 103.5 q0 56 -27.5 102.5t-74 74.5t-104.5 28q-57 0 -104 -28t-74.5 -74.5t-27.5 -102.5q0 -57 27.5 -103.5t74.5 -74t104 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 750,
    d: "M128 0l398 798h-430v102h599v-2l-445 -898h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 750,
    d: "M375 -12q-64 0 -120.5 23t-99.5 65t-67.5 97.5t-24.5 119.5q0 59 21 110.5t58 91.5t85 65q-29 28 -46 64t-17 81q0 44 16.5 81.5t45.5 66t67.5 44t81.5 15.5q44 0 82 -15.5t67 -44t45.5 -66t16.5 -81.5q0 -45 -17 -81.5t-46 -63.5q49 -25 85.5 -65t57.5 -91.5t21 -110.5 q0 -64 -24.5 -119.5t-67.5 -97.5t-99.5 -65t-120.5 -23zM375 90q57 0 103.5 27.5t73.5 73.5t27 103t-27 103.5t-73.5 73.5t-103.5 27t-103 -27t-73.5 -73.5t-27.5 -103.5t27.5 -103t73.5 -73.5t103 -27.5zM375 586q32 0 58 15.5t41.5 41.5t15.5 58t-15.5 58t-41.5 41.5 t-58 15.5t-58 -15.5t-41.5 -41.5t-15.5 -58t15.5 -58t41.5 -41.5t58 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 750,
    d: "M276 0l193 355q-27 -20 -56 -27.5t-58 -7.5q-58 0 -110.5 22t-92.5 61.5t-63 93t-23 116.5t24 117.5t66 95.5t97.5 63.5t118.5 22.5t118.5 -22.5t97.5 -63.5t66 -95.5t24 -117.5q0 -39 -9.5 -75t-26.5 -69l-242 -469h-124zM372 414q55 0 100 26.5t71.5 71.5t26.5 100 t-26.5 100t-71.5 71.5t-100 26.5t-100 -26.5t-71.5 -71.5t-26.5 -100t26.5 -100t71.5 -71.5t100 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    d: "M240 402q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5zM240 42q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5 t-27.5 -28t-40.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    d: "M240 402q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5zM86 -90q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 750,
    d: "M660 157l-600 292v2l600 292v-96l-300 -145q-28 -13 -59 -26l-62 -26q31 -12 62 -24.5t59 -26.5l300 -144v-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 750,
    d: "M90 519v90h570v-90h-570zM90 291v90h570v-90h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 750,
    d: "M90 157v96l300 145q28 14 59 26.5t62 25.5q-31 12 -62 25t-59 26l-300 144v98l600 -292v-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    d: "M192 300q0 59 15 104t37.5 81.5t45 69t37.5 65.5t15 70q0 54 -34 88t-88 34q-39 0 -73 -19.5t-57 -51.5v130q26 20 61.5 30.5t75.5 10.5q52 0 93 -16.5t70 -46t44.5 -67.5t15.5 -80q0 -45 -15.5 -83t-38 -73t-46.5 -72t-41 -79t-21 -95h-96zM240 -12q-21 0 -38 10t-27 27 t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1260,
    d: "M651 -192q-120 0 -224 42t-182.5 117t-122.5 174t-44 213q0 116 44 217.5t122.5 178t182.5 119.5t224 43q114 0 212.5 -39t172.5 -108.5t116 -162.5t42 -201q0 -80 -20.5 -140t-54 -99.5t-73.5 -59.5t-80 -20q-51 0 -92 27.5t-58 70.5q-37 -44 -90.5 -71t-116.5 -27 q-56 0 -104.5 21.5t-85.5 60t-58 89t-21 107.5t21 107.5t58 89t85.5 60t104.5 21.5t104.5 -20.5t84.5 -57.5v70h91v-382q0 -44 25 -66t57 -22q26 0 49 15.5t40.5 45.5t27.5 73.5t10 100.5q0 92 -34 170t-94.5 135.5t-141.5 89.5t-176 32q-102 0 -189 -36t-152 -100 t-101 -148t-36 -181t36 -180.5t101 -146t151.5 -97.5t186.5 -35q89 0 167 29.5t142 86.5l26 -100q-70 -51 -155 -78.5t-178 -27.5zM621 172q51 0 92.5 25.5t66 68t24.5 94.5t-24.5 94.5t-66 68t-92.5 25.5t-92.5 -25.5t-66 -68t-24.5 -94.5t24.5 -94.5t66 -68t92.5 -25.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 750,
    d: "M126 0v900h252q86 0 136.5 -34t72.5 -82.5t22 -91.5q0 -49 -22.5 -89.5t-60.5 -66.5q49 -22 85.5 -59t57.5 -85.5t21 -104.5q0 -54 -20 -105t-59.5 -92t-97.5 -65.5t-135 -24.5h-252zM240 102h130q74 0 119 29t66 73t21 87q0 42 -20 86t-65 73.5t-121 29.5h-130v-378z M240 576h129q40 0 69.5 12.5t46 37.5t16.5 60q0 37 -16.5 61.5t-45 37.5t-66.5 13h-133v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 900,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28 q95 0 172 45t123 118l33 -138q-64 -61 -148 -97t-180 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 960,
    d: "M126 0v900h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM240 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-696z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 600,
    d: "M126 0v900h444v-102h-330v-192h300v-102h-300v-504h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 800,
    d: "M126 0v900h114v-294h320v294h114v-900h-114v504h-320v-504h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 540,
    d: "M188 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 780,
    d: "M635 0l-383 555l308 345h134l-306 -344l386 -556h-139zM126 0v900h114v-900h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 600,
    d: "M126 0v900h114v-798h312v-102h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1080,
    d: "M126 0v930h2l416 -576l408 576h2v-930h-114v416q0 41 1 89.5t7 110.5q-31 -55 -60.5 -96.5t-53.5 -76.5l-194 -275l-200 275q-25 35 -53.5 76.5t-60.5 96.5q6 -62 7 -110.5t1 -89.5v-416h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 990,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 720,
    d: "M126 0v900h223q89 0 150.5 -27t99.5 -70.5t55.5 -94.5t17.5 -100q0 -48 -17 -99t-55 -95t-100 -71t-151 -27h-109v-316h-114zM240 418h103q81 0 128 28.5t67 72t20 89.5q0 44 -19.5 88t-66 73t-129.5 29h-103v-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1060,
    d: "M863 -30l-74 89q-55 -37 -121 -57t-138 -20q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182q0 -96 -36 -180t-98 -147l127 -153h-130zM530 90q52 0 98.5 14t86.5 39l-255 307 h134l200 -240q41 48 64.5 109.5t23.5 130.5q0 75 -27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 660,
    d: "M320 -12q-53 0 -100 15t-84 40t-63 55l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5l-33 -138 q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -77 -36.5 -137t-99.5 -94t-144 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 690,
    d: "M288 0v798h-240v102h594v-102h-240v-798h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 750,
    d: "M374 -30l-362 930h120l212 -542q10 -26 18.5 -49.5t16.5 -54.5q8 31 16.5 54.5t18.5 49.5l211 542h113l-362 -930h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1200,
    d: "M358 -30l-346 930h116l204 -540q11 -28 18 -53.5t15 -60.5q8 35 15.5 60.5t17.5 53.5l205 570h2l204 -570q9 -25 17.5 -50.5t15.5 -63.5q8 38 16 63.5t18 50.5l204 540h108l-345 -930h-2l-207 584q-9 26 -17 50.5t-16 62.5q-8 -38 -16 -62.5t-17 -50.5l-208 -584h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 870,
    d: "M6 0l361 522l-259 378h135l121 -180q19 -28 37 -57.5t36 -65.5q18 36 36 65.5t37 57.5l123 180h129l-259 -374l361 -526h-139l-202 300q-21 32 -43 65.5t-47 80.5q-25 -47 -47 -80.5t-43 -65.5l-204 -300h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 660,
    d: "M42 0v2l395 796h-353v102h522v-2l-395 -796h377v-102h-546z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    d: "M120 -180v1140h300v-90h-198v-960h198v-90h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    d: "M379 -180l-380 1140h102l380 -1140h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    d: "M60 -180v90h198v960h-198v90h300v-1140h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 750,
    d: "M82 192l293 600h2l291 -600h-98l-144 300q-13 28 -26 59t-25 62q-13 -31 -25.5 -62t-26.5 -59l-145 -300h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 750,
    d: "M-6 -180v90h762v-90h-762z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 720,
    d: "M377 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 760,
    d: "M407 -8q-62 0 -116 23.5t-95 63.5v-79h-100v960h108v-431q40 37 92 58t111 21q62 0 116 -24t95.5 -66.5t64.5 -98t23 -119.5t-23 -119.5t-64.5 -98t-95.5 -66.5t-116 -24zM393 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 630,
    d: "M372 -12q-66 0 -123.5 24.5t-101.5 67t-68.5 99.5t-24.5 121q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-43 -38 -100 -61t-122 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24q59 0 111 -21t92 -58v431h108v-960h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5 t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 450,
    d: "M166 0v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h149v-90h-146v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 720,
    d: "M96 0v960h108v-445q34 47 84 72t107 25q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 48 -19 89t-55 66t-88 25q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 300,
    d: "M31 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 630,
    d: "M487 0l-271 330l223 270h125l-219 -262l279 -338h-137zM96 0v960h108v-960h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 300,
    d: "M96 0v960h108v-960h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1120,
    d: "M96 0v600h100v-86q33 49 83.5 73.5t106.5 24.5q61 0 112 -28.5t82 -79.5q35 54 90.5 81t117.5 27q68 0 124.5 -32t90 -89.5t33.5 -135.5v-355h-108v342q0 82 -46.5 124.5t-107.5 42.5q-38 0 -73.5 -17t-58 -53t-22.5 -94v-345h-108v342q0 57 -22.5 94t-58 55.5 t-73.5 18.5q-37 0 -72.5 -17t-58.5 -53t-23 -95v-345h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 720,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 760,
    d: "M96 -300v900h100v-79q41 41 95 64t116 23t116 -24t95.5 -66.5t64.5 -98t23 -119.5t-23 -119.5t-64.5 -98t-95.5 -66.5t-116 -24q-59 0 -111 21t-92 58v-371h-108zM393 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 760,
    d: "M556 -300v371q-40 -37 -92 -58t-111 -21q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-900h-108zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 510,
    d: "M251 -12q-46 0 -98.5 17.5t-90.5 58.5l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -54 -26 -94.5t-70.5 -63.5t-102.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 450,
    d: "M166 0v510h-136v90h139v200h102v-200h149v-90h-146v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 630,
    d: "M314 -30l-302 630h123l122 -260q17 -35 32 -69t29 -83q15 49 30.5 83.5t31.5 68.5l123 260h115l-302 -630h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1000,
    d: "M314 -30l-302 630h123l121 -260q17 -37 32.5 -72t30.5 -88q16 52 32.5 88t31.5 72l120 288h2l119 -288q15 -37 31 -72t31 -88q15 53 31 88.5t33 71.5l123 260h115l-302 -630h-2l-121 268q-16 36 -31.5 71.5t-31.5 85.5q-15 -50 -31 -85.5t-33 -71.5l-120 -268h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 600,
    d: "M24 0l211 318l-188 282h126l58 -92q19 -29 37.5 -60.5t32.5 -64.5q15 33 33.5 64t37.5 61l57 92h124l-188 -282l211 -318h-128l-82 131q-18 29 -36 58.5t-32 61.5q-14 -32 -32 -61.5t-36 -58.5l-82 -131h-124z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 530,
    d: "M40 0v2l284 502h-266v96h432v-2l-284 -502h268v-96h-434z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    d: "M420 -186q-77 0 -140 29t-100 88t-37 149q0 28 3 54.5t6 52t3 49.5q0 64 -28.5 95.5t-84.5 58.5q56 27 84.5 58.5t28.5 95.5q0 24 -3 49.5t-6 52t-3 54.5q0 91 37 149.5t100 87.5t140 29v-90q-43 0 -83.5 -14.5t-66 -54t-25.5 -116.5q0 -28 3 -53t6 -49t3 -48 q0 -61 -24 -97.5t-64 -53.5q40 -16 64 -53t24 -98q0 -24 -3 -48t-6 -49t-3 -53q0 -76 25.5 -116t66 -54.5t83.5 -14.5v-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    d: "M192 -180v1140h96v-1140h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    d: "M60 -186v90q44 0 84 14.5t65.5 54.5t25.5 116q0 28 -3 53t-6 49t-3 48q0 61 24 98t64 53q-40 17 -64 53.5t-24 97.5q0 24 3 48t6 49t3 53q0 77 -25.5 116.5t-65.5 54t-84 14.5v90q77 0 140 -29t100 -87.5t37 -149.5q0 -28 -3 -54.5t-6 -52t-3 -49.5q0 -64 28.5 -95.5 t84.5 -58.5q-56 -27 -84.5 -58.5t-28.5 -95.5q0 -24 3 -49.5t6 -52t3 -54.5q0 -90 -37 -149t-100 -88t-140 -29z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 750,
    d: "M96 333l-48 83q27 59 76.5 91.5t107.5 32.5q40 0 76 -12.5t70 -29.5t67 -29.5t67 -12.5q50 0 85 31.5t57 79.5l48 -83q-27 -59 -76 -91.5t-108 -32.5q-40 0 -76 12.5t-70 29.5t-67 29.5t-67 12.5q-50 0 -84.5 -31.5t-57.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    d: "M186 -302l6 600h96l6 -600h-108zM240 460q-21 0 -38 10t-27 27t-10 38t10 38t27 27t38 10t38 -10t27 -27t10 -38t-10 -38t-27 -27t-38 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 750,
    d: "M378 0v142q-56 10 -104 37.5t-84 68.5t-56 92.5t-20 109.5t20 109.5t56 92.5t84 68.5t104 37.5v112h84v-109q56 -5 105.5 -27t86.5 -56l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5 q64 0 114.5 33t75.5 85l33 -136q-37 -34 -86.5 -56t-105.5 -27v-139h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 750,
    d: "M151 0v2q40 41 64.5 73.5t36.5 67t12 82.5q0 28 -3.5 58t-9 61.5t-11.5 63.5h-150v84h134q-5 34 -9 66t-4 62q0 92 36 157t96.5 100t132.5 35q59 0 105.5 -22t83.5 -60l-34 -138q-25 52 -63 85t-94 33q-64 0 -109.5 -49t-45.5 -150q0 -26 3.5 -56.5t7.5 -62.5h270v-84 h-256q6 -32 11 -64t8 -61.5t3 -56.5q0 -43 -8.5 -74.5t-24.5 -55.5h327v-96h-509z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 750,
    d: "M375 138q-52 0 -100 16t-88 44l-78 -78l-64 64l78 78q-30 39 -47 87t-17 101t16.5 100.5t46.5 86.5l-77 77l66 66l78 -78q39 29 86.5 44.5t99.5 15.5q53 0 100.5 -15.5t87.5 -44.5l78 78l64 -64l-78 -78q30 -39 47 -87t17 -101q0 -52 -16.5 -100t-46.5 -87l77 -77 l-66 -66l-78 78q-39 -28 -86 -44t-100 -16zM375 240q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 750,
    d: "M318 0v318h-228v84h228v33l-37 63h-191v84h143l-185 318h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-185 -318h143v-84h-191l-37 -63v-33h228v-84h-228v-318h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    d: "M192 -180v420h96v-420h-96zM192 540v420h96v-420h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 750,
    d: "M366 -192q-67 0 -125.5 28t-93.5 73l47 117q20 -54 68.5 -89t109.5 -35q39 0 68 16t45 43t16 60q0 37 -17.5 60.5t-40.5 37.5t-38 21l-175 82q-24 12 -60.5 34.5t-65.5 63.5t-29 106q0 51 20.5 92t57.5 69t86 41q-28 23 -48 57.5t-20 86.5q0 57 27 102.5t75.5 71.5 t112.5 26q62 0 113.5 -23.5t79.5 -54.5l-43 -110q-20 40 -62.5 68t-92.5 28q-33 0 -57.5 -13.5t-37.5 -36t-13 -49.5q0 -43 27.5 -67.5t51.5 -35.5l168 -77q24 -11 60.5 -34t65.5 -64t29 -107q0 -52 -20.5 -92.5t-56 -67.5t-82.5 -40q33 -24 60 -64.5t27 -103.5 q0 -64 -31 -114t-84.5 -78t-121.5 -28zM436 257q41 0 72 16.5t48 45.5t17 64q0 39 -18.5 64t-46 41t-53.5 29q-15 8 -30.5 15t-31 13.5t-30.5 12.5q-11 4 -23 5.5t-26 1.5q-41 0 -72 -16.5t-48 -44.5t-17 -64q0 -39 19.5 -64.5t47 -41.5t51.5 -29q15 -8 31 -15.5t32 -14 t32 -12.5q11 -3 22.5 -4.5t23.5 -1.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 720,
    d: "M240 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM480 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5 q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1260,
    d: "M630 -102q-115 0 -216.5 43t-178 119t-120 176t-43.5 214t43.5 214t120 176t178 119t216.5 43q116 0 217 -43t177.5 -119t120 -176t43.5 -214t-43.5 -214t-120 -176t-177.5 -119t-217 -43zM630 -12q96 0 179.5 36t147 99.5t99.5 147t36 179.5t-36 179.5t-99.5 147 t-147 99.5t-179.5 36t-179.5 -36t-147 -99.5t-99.5 -147t-36 -179.5t36 -179.5t99.5 -147t147 -99.5t179.5 -36zM648 168q-60 0 -112 22t-91.5 61t-61.5 90t-22 109t22 109t61.5 90t91.5 61t112 22q59 0 111 -20.5t90 -55.5l-30 -123q-23 46 -68.5 76.5t-103.5 30.5 q-52 0 -94.5 -26t-68 -69t-25.5 -95t25.5 -95t68 -69t94.5 -26q58 0 103.5 30t68.5 77l30 -123q-38 -34 -90 -55t-111 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    d: "M222 412q-50 0 -91 25.5t-65 68t-24 94.5t24.5 94.5t65.5 68t90 25.5q34 0 63.5 -12.5t50.5 -37.5v42h84v-360h-84v42q-21 -25 -50.5 -37.5t-63.5 -12.5zM234 490q30 0 54.5 15t39 40t14.5 55q0 31 -14.5 55.5t-39 39.5t-54.5 15t-54.5 -15t-39 -39.5t-14.5 -55.5 q0 -30 14.5 -55t39 -40t54.5 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 630,
    d: "M198 120l-192 180l192 180h132l-192 -180l192 -180h-132zM468 120l-192 180l192 180h132l-192 -180l192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 750,
    d: "M564 195v210h-504v90h600v-300h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 600,
    d: "M300 402q-55 0 -102.5 20t-84 55.5t-57 82t-20.5 100.5q0 72 35.5 130.5t95.5 93t133 34.5t133 -34.5t95.5 -93t35.5 -130.5q0 -54 -20.5 -100.5t-57 -82t-84 -55.5t-102.5 -20zM300 462q55 0 99.5 27t71.5 72t27 99q0 55 -27 99.5t-71.5 71.5t-99.5 27q-54 0 -99 -27 t-72 -71.5t-27 -99.5q0 -54 27 -99t72 -72t99 -27zM209 546v240h98q31 0 52.5 -11.5t33.5 -31t12 -43.5q0 -25 -12 -44t-34 -30l56 -80h-69l-48 70h-29v-70h-60zM269 664h36q20 0 30 10.5t10 24.5q0 17 -11 26t-29 9h-36v-70z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 720,
    d: "M183 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    d: "M240 558q-50 0 -92 24t-66.5 64t-24.5 89t24.5 89t66.5 64t92 24q51 0 92.5 -24t66 -64t24.5 -89t-24.5 -89t-66 -64t-92.5 -24zM240 633q29 0 53 14t38 37t14 51t-14 51t-38 37t-53 14t-53 -14t-38 -37t-14 -51t14 -51t38 -37t53 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 750,
    d: "M327 255v210h-237v90h237v240h96v-240h237v-90h-237v-210h-96zM90 77v86h570v-86h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    d: "M70 660v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    d: "M219 648q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 720,
    d: "M252 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    horizAdvX: 750,
    d: "M96 -300v900h108v-330q0 -47 19 -88.5t55.5 -66.5t87.5 -25q42 0 79 20.5t60 60t23 96.5v333h108v-422q0 -55 24.5 -76t62.5 -21l-22 -93q-37 0 -69 12.5t-55.5 37t-36.5 60.5q-29 -54 -77 -82t-103 -28q-46 0 -86 19t-70 55v-362h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\u03BC",
    horizAdvX: 750,
    d: "M96 -300v900h108v-330q0 -47 19 -88.5t55.5 -66.5t87.5 -25q42 0 79 20.5t60 60t23 96.5v333h108v-422q0 -55 24.5 -76t62.5 -21l-22 -93q-37 0 -69 12.5t-55.5 37t-36.5 60.5q-29 -54 -77 -82t-103 -28q-46 0 -86 19t-70 55v-362h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 750,
    d: "M324 -180v558q-101 10 -161.5 57t-87.5 110.5t-27 122.5q0 49 17.5 100t55.5 94.5t99.5 70.5t150.5 27h265v-1140h-96v1044h-120v-1044h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 360,
    d: "M180 222q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 720,
    d: "M204 -180l178 180h108l-143 -180h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    d: "M228 660v371l-114 -57v84l202 102h2v-500h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    d: "M240 408q-55 0 -100 26t-71.5 69.5t-26.5 96.5t26.5 96.5t71.5 69.5t100 26t100 -26t71.5 -69.5t26.5 -96.5t-26.5 -96.5t-71.5 -69.5t-100 -26zM240 489q32 0 57.5 15t41 40.5t15.5 55.5q0 31 -15.5 56t-41 40t-57.5 15t-58 -15t-41 -40t-15 -56q0 -30 15 -55.5 t41 -40.5t58 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 630,
    d: "M30 120l192 180l-192 180h132l192 -180l-192 -180h-132zM300 120l192 180l-192 180h132l192 -180l-192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1080,
    d: "M228 420v371l-114 -57v84l202 102h2v-500h-90zM186 0l618 900h90l-618 -900h-90zM872 0v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1080,
    d: "M228 420v371l-114 -57v84l202 102h2v-500h-90zM166 0l618 900h90l-618 -900h-90zM670 0v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5 q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 1080,
    d: "M219 408q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z M186 0l618 900h90l-618 -900h-90zM872 0v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    d: "M253 -312q-52 0 -93 16.5t-70 46t-44.5 67.5t-15.5 80q0 45 15.5 83t38 73t46.5 72t41 79.5t21 94.5h96q0 -59 -15 -104t-37.5 -81.5t-45 -69t-37.5 -65t-15 -70.5q0 -54 34 -88t88 -34q39 0 73 19.5t57 51.5v-130q-26 -19 -61 -30t-76 -11zM240 462q-21 0 -38 10t-27 27 t-10 38t10 38t27 27t38 10t38 -10t27 -27t10 -38t-10 -38t-27 -27t-38 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM346 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM346 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM203 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5 t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM556 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5 t-25.5 -26t-37 -9.5zM244 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 800,
    d: "M18 0l345 838q-35 8 -62.5 29.5t-43.5 53.5t-16 69q0 44 21.5 79.5t57.5 56t80 20.5t80 -20.5t57.5 -56t21.5 -79.5q0 -37 -16 -68.5t-43.5 -53t-62.5 -30.5l345 -838h-121l-106 267h-315l-107 -267h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5 t-25 -67.5zM400 906q34 0 59 25t25 59t-25 59t-59 25t-59 -25t-25 -59t25 -59t59 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1020,
    d: "M18 0l370 900h348l26 -102h-265l59 -192h221l24 -102h-214l123 -402h254l26 -102h-363l-82 267h-305l-107 -267h-115zM278 362h238l-54 178q-12 41 -24.5 82.5t-24.5 90.5q-16 -49 -32 -90.5t-32 -82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 900,
    d: "M298 -180l165 167q-85 12 -158.5 52.5t-128.5 102.5t-85.5 141t-30.5 167q0 97 36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5 t112 -77.5t138 -28q95 0 172 45t123 118l33 -138q-57 -55 -130 -89.5t-157 -41.5l-130 -164h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM294 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM294 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM159 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM468 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM228 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49 q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM141 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM141 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM6 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM315 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM75 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 990,
    d: "M156 0v438h-96v84h96v378h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM270 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-276h270v-84h-270v-336z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 990,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM268 933l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM476 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM476 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM333 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37 t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM800 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM260 918 q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 750,
    d: "M169 180l-64 64l205 205l-205 205l66 66l205 -205l205 205l64 -64l-205 -205l205 -205l-66 -66l-205 205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1060,
    d: "M530 -18q-72 0 -137.5 20t-121.5 57l-70 -84l-71 59l69 83q-43 43 -74 95.5t-48 112.5t-17 125q0 97 36.5 182t101 149t150 100.5t182.5 36.5q74 0 142 -21.5t125 -60.5l62 75l71 -59l-63 -76q41 -42 71 -93.5t46 -110t16 -122.5q0 -97 -36.5 -182t-101 -149 t-149.5 -100.5t-183 -36.5zM271 204l455 546q-42 29 -91.5 44.5t-104.5 15.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -47 11 -91t32 -83t50 -72zM530 90q74 0 138 28t112 77.5t75 114.5t27 140q0 69 -23 130t-64 109l-453 -544q41 -26 88.5 -40.5t99.5 -14.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM346 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM346 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5 q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM520 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20 t20 -49q0 -28 -20 -48.5t-49 -20.5zM280 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM292 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 720,
    d: "M126 0v900h114v-120h109q89 0 150.5 -27t99.5 -70.5t55.5 -94.5t17.5 -100q0 -48 -17 -99t-55 -95t-100 -71t-151 -27h-109v-196h-114zM240 298h103q81 0 128 28.5t67 72t20 89.5q0 44 -19.5 88t-66 73t-129.5 29h-103v-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 750,
    d: "M361 -12l-24 96q62 2 110.5 31.5t76.5 80t28 115.5q0 60 -26.5 109t-80 87t-134.5 66v2q70 34 108 78.5t38 96.5q0 53 -35.5 89.5t-89.5 36.5q-36 0 -65 -18t-46 -51.5t-17 -79.5v-727h-108v727q0 74 31.5 129t85 85.5t120.5 30.5q66 0 118.5 -29t83 -77.5t30.5 -109.5 q0 -51 -21.5 -89.5t-54.5 -67.5q53 -26 92.5 -69t62 -97.5t22.5 -118.5q0 -65 -23.5 -122t-65.5 -101t-97 -71t-119 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM326 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM325 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM187 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM251 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM491 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9 q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM371 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5 t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1140,
    d: "M286 -12q-65 0 -118 25t-83.5 69t-30.5 102q0 61 34 104.5t92.5 66.5t133.5 23q51 0 97 -11t84 -31q2 11 4 22.5t4 22.5q-10 56 -55.5 93.5t-124.5 37.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q77 0 138.5 -27t97.5 -76q41 49 99.5 78t126.5 29 q83 0 151.5 -39.5t109.5 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5t-117.5 -19.5q-84 0 -152 36t-110 97q-29 -43 -70 -72.5t-90 -45t-104 -15.5zM294 82q47 0 90.5 17t76 46.5t45.5 68.5 l-7 35q-39 18 -86 28.5t-92 10.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM591 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90 -22.5t-69.5 -59.5t-38.5 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 630,
    d: "M139 -180l172 174q-73 14 -131.5 57.5t-92 108t-33.5 140.5q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-35 -31 -80 -52.5t-96 -28.5l-136 -171h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM313 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM312 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM169 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM238 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5 t-24.5 -25t-35.5 -9.5zM478 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM105 690l-85 180h126l50 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM104 690l60 180h126l-95 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM-39 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM54 711q-19 0 -33 9.5t-22 25t-8 34.5q0 20 8 35.5t22 24.5t33 9q20 0 34 -9t21.5 -24.5t7.5 -35.5q0 -19 -7.5 -34.5t-21.5 -25t-34 -9.5zM246 711q-19 0 -33 9.5t-22 25t-8 34.5q0 20 8 35.5t22 24.5t33 9q20 0 34 -9t21.5 -24.5t7.5 -35.5 q0 -19 -7.5 -34.5t-21.5 -25t-34 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 740,
    d: "M371 -12q-66 0 -123.5 24t-101 67t-68 100t-24.5 122q0 63 23 118.5t64 97.5t94.5 65.5t114.5 23.5q44 0 83.5 -12.5t71.5 -41.5q-36 53 -76 105.5t-83 104.5l-138 -90l-38 60l130 85q-20 24 -40.5 48t-40.5 47.5t-41 47.5h123q19 -22 38.5 -45t38.5 -47l127 82l38 -59 l-120 -78q53 -66 97.5 -125.5t68.5 -96.5q51 -79 74 -147.5t23 -133.5q0 -70 -24 -128.5t-67.5 -102t-100.5 -67.5t-123 -24zM369 90q58 0 105.5 28.5t75.5 76.5t28 106t-28 105t-75.5 75.5t-105.5 28.5q-57 0 -104 -28.5t-75 -75.5t-28 -105t28 -106t75 -76.5t104 -28.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 720,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM176 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20 t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM325 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM324 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM181 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM186 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM250 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM490 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5 t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 750,
    d: "M60 405v90h630v-90h-630zM375 171q-29 0 -49 20t-20 49t20 49t49 20q30 0 49.5 -20t19.5 -49t-19.5 -49t-49.5 -20zM375 591q-29 0 -49 20t-20 49t20 49t49 20q30 0 49.5 -20t19.5 -49t-19.5 -49t-49.5 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 740,
    d: "M370 -12q-47 0 -90.5 13t-80.5 36l-46 -55l-61 53l45 54q-39 41 -61 95.5t-22 115.5q0 65 24.5 121.5t68 99.5t100.5 67t123 24q47 0 89 -12t78 -35l44 52l61 -53l-42 -50q40 -42 63 -97t23 -117q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM202 166l271 323 q-22 13 -48 20t-55 7q-59 0 -108 -29t-77.5 -78t-28.5 -109q0 -38 12 -72t34 -62zM370 84q59 0 107.5 29t77.5 78t29 109q0 39 -13 74t-36 63l-272 -324q23 -14 50.5 -21.5t56.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM315 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM314 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5 h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM240 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9 t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM480 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM283 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 760,
    d: "M96 -300v1260h108v-431q40 37 92 58t111 21q62 0 116 -24t95.5 -66.5t64.5 -98t23 -119.5t-23 -119.5t-64.5 -98t-95.5 -66.5t-116 -24q-59 0 -111 21t-92 58v-371h-108zM393 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM209 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5 zM449 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM223 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM194 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62 t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 800,
    d: "M736 -312q-71 0 -118 43t-47 108q0 43 22.5 83t67.5 78l-106 266h-315l-107 -266h-115l381 930h2l381 -930q-52 -27 -81.5 -65t-29.5 -79q0 -35 23 -55t64 -20zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 760,
    d: "M669 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75v79q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5t62.5 -19.5zM367 90 q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 900,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28 q95 0 172 45t123 118l33 -138q-64 -61 -148 -97t-180 -36zM476 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 630,
    d: "M372 -12q-66 0 -123.5 24.5t-101.5 67t-68.5 99.5t-24.5 121q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-43 -38 -100 -61t-122 -23zM325 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 900,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28 q95 0 172 45t123 118l33 -138q-64 -61 -148 -97t-180 -36zM341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 630,
    d: "M372 -12q-66 0 -123.5 24.5t-101.5 67t-68.5 99.5t-24.5 121q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-43 -38 -100 -61t-122 -23zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 900,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28 q95 0 172 45t123 118l33 -138q-64 -61 -148 -97t-180 -36zM530 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 630,
    d: "M372 -12q-66 0 -123.5 24.5t-101.5 67t-68.5 99.5t-24.5 121q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-43 -38 -100 -61t-122 -23zM371 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 900,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28 q95 0 172 45t123 118l33 -138q-64 -61 -148 -97t-180 -36zM529 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 630,
    d: "M372 -12q-66 0 -123.5 24.5t-101.5 67t-68.5 99.5t-24.5 121q0 65 24.5 121.5t68.5 99t101.5 67t123.5 24.5q65 0 122 -23t100 -61l-33 -136q-25 50 -75.5 84t-114.5 34q-58 0 -105.5 -28.5t-75.5 -76t-28 -105.5q0 -57 28 -105t75.5 -76.5t105.5 -28.5q64 0 114.5 33 t75.5 85l33 -136q-43 -38 -100 -61t-122 -23zM370 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 960,
    d: "M126 0v900h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM240 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-696zM406 981l-188 219h114 q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 940,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24q59 0 111 -21t92 -58v431h108v-960h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5 t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM720 660q45 56 72.5 130t27.5 170h96q0 -86 -23.5 -161t-64.5 -139h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 990,
    d: "M156 0v438h-96v84h96v378h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM270 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-276h270v-84h-270v-336z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t115.5 -23t93.5 -61v222h-212v68h212v146h102v-146h66v-68h-66v-746h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76 t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM171 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM181 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM348 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM358 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62 t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM348 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM358 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 630,
    d: "M575 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75h-344v900h444v-102h-330v-192h260v-102h-260v-402h330v-102q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 710,
    d: "M553 -312q-65 0 -115 41.5t-50 117.5q0 38 14.5 74t41.5 72q-16 -2 -31 -3.5t-31 -1.5q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96 t77.5 -67.5t104 -24.5q59 0 109 23t79 60l27 -111q-64 -71 -87 -114.5t-23 -81.5q0 -46 24.5 -65.5t62.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM347 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM357 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5zM341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM192 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5 t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5zM530 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM381 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27 t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5zM530 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM381 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5 q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0122",
    unicode: "\u0122",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5zM391 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0123",
    unicode: "\u0123",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM329 720q5 59 24.5 111.5t49.5 98.5h116q-34 -42 -57.5 -94t-28.5 -116h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 800,
    d: "M126 0v900h114v-294h320v294h114v-900h-114v504h-320v-504h-114zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 720,
    d: "M96 0v960h108v-445q34 47 84 72t107 25q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 48 -19 89t-55 66t-88 25q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM-39 1050l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 800,
    d: "M126 0v678h-96v84h96v138h114v-138h320v138h114v-138h96v-84h-96v-678h-114v444h-320v-444h-114zM240 546h320v132h-320v-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 720,
    d: "M96 0v746h-66v68h66v146h102v-146h212v-68h-212v-240q33 52 85 79t112 27q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 48 -19 89t-55 66t-88 25q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM-2 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM-34 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM18 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM3 740v80h294v-80h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM195 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM150 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 390,
    d: "M250 -312q-65 0 -115 41.5t-50 117.5q0 40 14 78t39 75v900h114v-900q-32 -29 -49.5 -62.5t-17.5 -71.5q0 -46 24.5 -65.5t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 300,
    d: "M205 -312q-65 0 -115 41.5t-50 117.5q0 40 15 78t41 75v600h108v-600q-29 -34 -46.5 -65t-17.5 -69q0 -46 24.5 -65.5t62.5 -19.5zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26 t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM195 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 930,
    d: "M138 0v900h114v-900h-114zM578 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 600,
    d: "M96 0v600h108v-600h-108zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM331 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM450 708 q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 540,
    d: "M188 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5zM186 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 300,
    d: "M31 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM-39 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0136",
    unicode: "\u0136",
    horizAdvX: 780,
    d: "M635 0l-383 555l308 345h134l-306 -344l386 -556h-139zM126 0v900h114v-900h-114zM300 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0137",
    unicode: "\u0137",
    horizAdvX: 630,
    d: "M487 0l-271 330l223 270h125l-219 -262l279 -338h-137zM96 0v960h108v-960h-108zM192 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 630,
    d: "M487 0l-271 330l223 270h125l-219 -262l279 -338h-137zM96 0v600h108v-600h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 600,
    d: "M126 0v900h114v-798h312v-102h-426zM129 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 300,
    d: "M96 0v960h108v-960h-108zM96 1050l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013B",
    unicode: "\u013B",
    horizAdvX: 600,
    d: "M126 0v900h114v-798h312v-102h-426zM201 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C",
    unicode: "\u013C",
    horizAdvX: 300,
    d: "M96 0v960h108v-960h-108zM12 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 600,
    d: "M126 0v900h114v-798h312v-102h-426zM308 600q45 56 72.5 130t27.5 170h96q0 -86 -23.5 -161t-64.5 -139h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    d: "M96 0v960h108v-960h-108zM260 660q45 56 72.5 130t27.5 170h96q0 -86 -23.5 -161t-64.5 -139h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 600,
    d: "M126 0v900h114v-798h312v-102h-426zM420 408q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 420,
    d: "M96 0v960h108v-960h-108zM360 348q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 630,
    d: "M156 0v369l-90 -59l-42 64l132 86v440h114v-365l204 133l42 -64l-246 -161v-341h312v-102h-426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 360,
    d: "M126 0v404l-96 -63l-38 60l134 88v471h108v-400l90 59l38 -60l-128 -84v-475h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 990,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM411 930l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 720,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM314 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0145",
    unicode: "\u0145",
    horizAdvX: 990,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM357 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0146",
    unicode: "\u0146",
    horizAdvX: 720,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM222 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 990,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM464 921l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 720,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM359 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 990,
    d: "M626 -192q-48 0 -95 15t-81 51l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v10l-522 559v-645h-108v930h2l628 -675v645h108v-839q0 -87 -33 -143t-87.5 -83t-117.5 -27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 720,
    d: "M463 -312l-22 93q38 0 62.5 21t24.5 76v452q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-469q0 -90 -49.5 -139t-123.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM353 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM193 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM370 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM598 990l66 180h120l-101 -180h-85zM376 990l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM438 690l66 180h120l-101 -180h-85zM216 690l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1380,
    d: "M529 -18q-96 0 -180.5 36.5t-149.5 100.5t-102 149t-37 182t36.5 182t100.5 149t149.5 100.5t182.5 36.5q74 0 140 -22t120.5 -61.5t92.5 -93.5v159h438v-102h-330v-192h260v-102h-260v-402h330v-102h-438v159q-38 -53 -92.5 -93t-120.5 -62t-140 -22zM530 90 q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1210,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q76 0 140.5 -32t107.5 -86q42 54 105 86t136 32q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123 q-43 -35 -98.5 -54.5t-117.5 -19.5q-82 0 -149.5 33t-111.5 88q-43 -55 -108.5 -88t-142.5 -33zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM661 351q27 5 54.5 7t54.5 2h199 q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90 -22.5t-69.5 -59.5t-38.5 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288zM271 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108zM206 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0156",
    unicode: "\u0156",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288zM301 -330q34 42 57.5 94t28.5 116h104 q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0157",
    unicode: "\u0157",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108zM12 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288zM324 981l-188 219h114q21 -21 38 -43.5 t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108zM251 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 660,
    d: "M320 -12q-53 0 -100 15t-84 40t-63 55l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5l-33 -138 q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -77 -36.5 -137t-99.5 -94t-144 -34zM289 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 510,
    d: "M251 -12q-46 0 -98.5 17.5t-90.5 58.5l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -54 -26 -94.5t-70.5 -63.5t-102.5 -23zM212 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 660,
    d: "M320 -12q-53 0 -100 15t-84 40t-63 55l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5l-33 -138 q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -77 -36.5 -137t-99.5 -94t-144 -34zM154 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5 q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 510,
    d: "M251 -12q-46 0 -98.5 17.5t-90.5 58.5l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -54 -26 -94.5t-70.5 -63.5t-102.5 -23zM69 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 660,
    d: "M90 -180l171 173q-60 11 -108.5 39.5t-79.5 65.5l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5 l-33 -138q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -69 -29.5 -124.5t-81.5 -91t-120 -45.5l-136 -172h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 510,
    d: "M23 -180l172 174q-36 7 -71 24t-62 46l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -68 -40.5 -114.5t-105.5 -60.5l-138 -174h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 660,
    d: "M320 -12q-53 0 -100 15t-84 40t-63 55l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5l-33 -138 q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -77 -36.5 -137t-99.5 -94t-144 -34zM342 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5 t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 510,
    d: "M251 -12q-46 0 -98.5 17.5t-90.5 58.5l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -54 -26 -94.5t-70.5 -63.5t-102.5 -23zM257 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 690,
    d: "M113 -180l175 180v798h-240v102h594v-102h-240v-798l-146 -180h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 450,
    d: "M-12 -180l178 180v510h-136v90h139v200h102v-200h149v-90h-146v-510l-143 -180h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 690,
    d: "M288 0v798h-240v102h594v-102h-240v-798h-114zM344 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 540,
    d: "M166 0v510h-136v90h139v200h102v-200h149v-90h-146v-510h-108zM350 720q38 47 64 106.5t33 133.5h96q-7 -67 -29 -127t-56 -113h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 690,
    d: "M288 0v408h-183v84h183v306h-240v102h594v-102h-240v-306h183v-84h-183v-408h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 450,
    d: "M166 0v266h-126v68h126v176h-136v90h139v200h102v-200h149v-90h-146v-176h136v-68h-136v-266h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM203 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5 t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM176 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20 t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM223 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM183 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM400 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27 t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM360 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88 q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM400 951q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17 t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM400 1017q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM360 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66 t-17.5 -66t-47.5 -46t-67 -17zM360 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM468 990l66 180h120l-101 -180h-85zM246 990l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM428 690l66 180h120l-101 -180h-85zM206 690l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 800,
    d: "M485 -312q-65 0 -115 41.5t-50 117.5q0 29 10 62.5t41 79.5q-77 7 -136.5 45.5t-93 102.5t-33.5 146v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -74 -27 -134t-75 -100.5t-112 -55.5q-27 -33 -42.5 -63t-15.5 -68 q0 -46 24.5 -65.5t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 720,
    d: "M629 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75v97q-33 -53 -85.5 -81t-113.5 -28q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5 t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1200,
    d: "M358 -30l-346 930h116l204 -540q11 -28 18 -53.5t15 -60.5q8 35 15.5 60.5t17.5 53.5l205 570h2l204 -570q9 -25 17.5 -50.5t15.5 -63.5q8 38 16 63.5t18 50.5l204 540h108l-345 -930h-2l-207 584q-9 26 -17 50.5t-16 62.5q-8 -38 -16 -62.5t-17 -50.5l-208 -584h-2z M415 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 1000,
    d: "M314 -30l-302 630h123l121 -260q17 -37 32.5 -72t30.5 -88q16 52 32.5 88t31.5 72l120 288h2l119 -288q15 -37 31 -72t31 -88q15 53 31 88.5t33 71.5l123 260h115l-302 -630h-2l-121 268q-16 36 -31.5 71.5t-31.5 85.5q-15 -50 -31 -85.5t-33 -71.5l-120 -268h-2z M315 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM157 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM140 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM466 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM226 1011q-28 0 -48.5 20.5 t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 660,
    d: "M42 0v2l395 796h-353v102h522v-2l-395 -796h377v-102h-546zM291 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 530,
    d: "M40 0v2l284 502h-266v96h432v-2l-284 -502h268v-96h-434zM228 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 660,
    d: "M42 0v2l395 796h-353v102h522v-2l-395 -796h377v-102h-546zM345 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 530,
    d: "M40 0v2l284 502h-266v96h432v-2l-284 -502h268v-96h-434zM274 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 660,
    d: "M42 0v2l395 796h-353v102h522v-2l-395 -796h377v-102h-546zM344 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 530,
    d: "M40 0v2l284 502h-266v96h432v-2l-284 -502h268v-96h-434zM273 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni018F",
    unicode: "\u018F",
    horizAdvX: 1050,
    d: "M520 -18q-96 0 -180.5 36.5t-148.5 101t-100.5 150.5t-36.5 185v28v27h700q29 0 57.5 -2.5t57.5 -6.5q-9 66 -39 122t-76.5 98t-106 65.5t-127.5 23.5q-94 0 -171 -44.5t-124 -118.5l-33 138q43 41 94.5 71t110.5 46t123 16q98 0 183 -36.5t149.5 -100.5t101 -149 t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM520 90q70 0 131 25t108.5 70t76.5 104.5t35 128.5q-29 -4 -58.5 -7t-58.5 -3h-580q8 -67 37 -125t75.5 -101t106 -67.5t127.5 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 750,
    d: "M230 -192q-30 0 -61.5 7t-59.5 24l26 105q42 -46 98 -46q23 0 43.5 9.5t33.5 34t13 68.5v395h-203v90h203v217q0 66 27 110.5t72 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34 -34t-13 -68.5v-215h203v-90h-203v-397 q0 -65 -27 -110t-71.5 -67.5t-98.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohorn",
    unicode: "\u01A0",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohorn",
    unicode: "\u01A1",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhorn",
    unicode: "\u01AF",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhorn",
    unicode: "\u01B0",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01B7",
    unicode: "\u01B7",
    horizAdvX: 660,
    d: "M302 -12q-87 0 -159 41t-113 112l68 134q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 102.5 27.5t72.5 73.5t27 103q0 56 -27 102.5t-73 74t-102 27.5q-26 0 -49.5 -6.5t-41.5 -18.5l-2 2l164 317h-289v102h461v-2l-163 -303q50 -11 92.5 -37.5t75 -65t50.5 -87.5t18 -105 q0 -66 -24.5 -122.5t-68 -99t-101 -66.5t-122.5 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1590,
    d: "M126 0v900h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM240 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-696zM972 0v2l395 796h-353v102h522v-2 l-395 -796h377v-102h-546zM1274 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1490,
    d: "M126 0v900h295q122 0 212.5 -40t149.5 -106t88 -145.5t29 -158.5t-29 -158.5t-88 -145.5t-149.5 -106t-212.5 -40h-295zM240 102h169q104 0 175 32.5t115 85t63.5 113.5t19.5 117t-19.5 117t-63.5 113.5t-115 85t-175 32.5h-169v-696zM1000 0v2l284 502h-266v96h432v-2 l-284 -502h268v-96h-434zM1233 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1290,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24q59 0 111 -21t92 -58v431h108v-960h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5 t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM800 0v2l284 502h-266v96h432v-2l-284 -502h268v-96h-434zM1033 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1140,
    d: "M126 0v900h114v-798h312v-102h-426zM788 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 900,
    d: "M126 0v900h114v-798h312v-102h-426zM631 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM750 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 600,
    d: "M96 0v960h108v-960h-108zM331 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM450 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1530,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM1178 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 1290,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM1021 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM1140 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 1020,
    d: "M96 0v600h100v-97q33 53 85.5 81t113.5 28q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330q0 71 -42.5 125.5t-119.5 54.5q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108zM751 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM870 708 q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E4",
    unicode: "\u01E4",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v176h-238v84h238v138h110v-138h72v-84h-72v-234q-61 -51 -141.5 -76.5t-167.5 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E5",
    unicode: "\u01E5",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-266h70v-68h-70 v-266q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q52 0 95 23t71.5 63t35.5 90h-215v68h215q-7 50 -35.5 90t-71.5 63t-95 23q-57 0 -103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcaron",
    unicode: "\u01E6",
    horizAdvX: 940,
    d: "M529 -18q-98 0 -183 36.5t-149.5 101t-100.5 149t-36 181.5t36.5 181.5t101 149t149.5 101t183 36.5q96 0 180 -35.5t148 -97.5l-33 -138q-46 74 -123.5 118.5t-171.5 44.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -73 26.5 -138.5t74.5 -115t111.5 -78 t138.5 -28.5q56 0 106.5 13.5t92.5 38.5v236h-248v102h358v-396q-61 -51 -141.5 -76.5t-167.5 -25.5zM529 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcaron",
    unicode: "\u01E7",
    horizAdvX: 760,
    d: "M339 -312q-46 0 -86.5 9t-75.5 26t-64 40l30 122q30 -43 80 -70t115 -27q67 0 118 28t79.5 77t28.5 113v73q-40 -40 -94.5 -63.5t-116.5 -23.5t-116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600 q0 -98 -45.5 -168t-119.5 -107t-160 -37zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM380 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110 l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E8",
    unicode: "\u01E8",
    horizAdvX: 780,
    d: "M635 0l-383 555l308 345h134l-306 -344l386 -556h-139zM126 0v900h114v-900h-114zM369 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01E9",
    unicode: "\u01E9",
    horizAdvX: 630,
    d: "M487 0l-271 330l223 270h125l-219 -262l279 -338h-137zM96 0v960h108v-960h-108zM149 1041l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EA",
    unicode: "\u01EA",
    horizAdvX: 1060,
    d: "M615 -312q-65 0 -115 41.5t-50 117.5q0 35 12.5 69t35.5 67q-92 6 -171.5 44.5t-139.5 102t-93.5 145.5t-33.5 175q0 97 36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182q0 -88 -30.5 -166.5t-85 -141t-127 -103t-157.5 -52.5 q-23 -30 -36.5 -58t-13.5 -63q0 -46 24.5 -65.5t62.5 -19.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EB",
    unicode: "\u01EB",
    horizAdvX: 740,
    d: "M455 -312q-65 0 -115 41.5t-50 117.5q0 37 13.5 72.5t38.5 69.5q-61 5 -113 31t-91.5 68t-61.5 96.5t-22 115.5q0 65 24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5q0 -73 -31 -135.5t-84.5 -106t-122.5 -61.5q-27 -32 -42.5 -62.5 t-15.5 -68.5q0 -46 24.5 -65.5t62.5 -19.5zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EE",
    unicode: "\u01EE",
    horizAdvX: 660,
    d: "M302 -12q-87 0 -159 41t-113 112l68 134q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 102.5 27.5t72.5 73.5t27 103q0 56 -27 102.5t-73 74t-102 27.5q-26 0 -49.5 -6.5t-41.5 -18.5l-2 2l164 317h-289v102h461v-2l-163 -303q50 -11 92.5 -37.5t75 -65t50.5 -87.5t18 -105 q0 -66 -24.5 -122.5t-68 -99t-101 -66.5t-122.5 -24zM312 981l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01EF",
    unicode: "\u01EF",
    horizAdvX: 660,
    d: "M302 -312q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 102.5 27.5t72.5 74t27 102.5t-27 102.5t-73 74t-102 27.5q-28 0 -52 -7t-43 -18l-2 2l171 329h-278v96h444v-2l-169 -313q50 -10 93.5 -35.5t76 -64t51 -87t18.5 -104.5 q0 -64 -24 -120t-67 -97.5t-99 -65t-120 -23.5zM319 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 800,
    d: "M18 0l345 838q-35 8 -62.5 29.5t-43.5 53.5t-16 69q0 44 21.5 79.5t57.5 56t80 20.5t80 -20.5t57.5 -56t21.5 -79.5q0 -37 -16 -68.5t-43.5 -53t-62.5 -30.5l345 -838h-121l-106 267h-315l-107 -267h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5 t-25 -67.5zM400 906q34 0 59 25t25 59t-25 59t-59 25t-59 -25t-25 -59t25 -59t59 -25zM364 1206l56 111h105l-77 -111h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM371 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5 t44.5 -18.5zM335 957l56 123h105l-77 -123h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 1020,
    d: "M18 0l370 900h348l26 -102h-265l59 -192h221l24 -102h-214l123 -402h254l26 -102h-363l-82 267h-305l-107 -267h-115zM278 362h238l-54 178q-12 41 -24.5 82.5t-24.5 90.5q-16 -49 -32 -90.5t-32 -82.5zM533 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 1140,
    d: "M286 -12q-65 0 -118 25t-83.5 69t-30.5 102q0 61 34 104.5t92.5 66.5t133.5 23q51 0 97 -11t84 -31q2 11 4 22.5t4 22.5q-10 56 -55.5 93.5t-124.5 37.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q77 0 138.5 -27t97.5 -76q41 49 99.5 78t126.5 29 q83 0 151.5 -39.5t109.5 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5t-117.5 -19.5q-84 0 -152 36t-110 97q-29 -43 -70 -72.5t-90 -45t-104 -15.5zM294 82q47 0 90.5 17t76 46.5t45.5 68.5 l-7 35q-39 18 -86 28.5t-92 10.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM591 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90 -22.5t-69.5 -59.5t-38.5 -83zM524 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 1060,
    d: "M530 -18q-72 0 -137.5 20t-121.5 57l-70 -84l-71 59l69 83q-43 43 -74 95.5t-48 112.5t-17 125q0 97 36.5 182t101 149t150 100.5t182.5 36.5q74 0 142 -21.5t125 -60.5l62 75l71 -59l-63 -76q41 -42 71 -93.5t46 -110t16 -122.5q0 -97 -36.5 -182t-101 -149 t-149.5 -100.5t-183 -36.5zM271 204l455 546q-42 29 -91.5 44.5t-104.5 15.5q-74 0 -138 -28t-112 -77.5t-75 -114.5t-27 -140q0 -47 11 -91t32 -83t50 -72zM530 90q74 0 138 28t112 77.5t75 114.5t27 140q0 69 -23 130t-64 109l-453 -544q41 -26 88.5 -40.5t99.5 -14.5z M476 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 740,
    d: "M370 -12q-47 0 -90.5 13t-80.5 36l-46 -55l-61 53l45 54q-39 41 -61 95.5t-22 115.5q0 65 24.5 121.5t68 99.5t100.5 67t123 24q47 0 89 -12t78 -35l44 52l61 -53l-42 -50q40 -42 63 -97t23 -117q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM202 166l271 323 q-22 13 -48 20t-55 7q-59 0 -108 -29t-77.5 -78t-28.5 -109q0 -38 12 -72t34 -62zM370 84q59 0 107.5 29t77.5 78t29 109q0 39 -13 74t-36 63l-272 -324q23 -14 50.5 -21.5t56.5 -7.5zM324 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0200",
    unicode: "\u0200",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM469 990l-101 180h120l66 -180h-85zM247 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0201",
    unicode: "\u0201",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM440 690l-101 180h120l66 -180h-85zM218 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0202",
    unicode: "\u0202",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM220 975q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0203",
    unicode: "\u0203",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM191 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0204",
    unicode: "\u0204",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM417 990l-101 180h120l66 -180h-85zM195 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0205",
    unicode: "\u0205",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM427 690l-101 180h120l66 -180h-85zM205 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0206",
    unicode: "\u0206",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM168 975q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0207",
    unicode: "\u0207",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM178 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0208",
    unicode: "\u0208",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM264 990l-101 180h120l66 -180h-85zM42 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0209",
    unicode: "\u0209",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM219 690l-101 180h120l66 -180h-85zM-3 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020A",
    unicode: "\u020A",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM15 975q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020B",
    unicode: "\u020B",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM-30 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020C",
    unicode: "\u020C",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM599 990l-101 180h120l66 -180h-85zM377 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020D",
    unicode: "\u020D",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM439 690l-101 180h120l66 -180h-85zM217 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020E",
    unicode: "\u020E",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM350 975q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni020F",
    unicode: "\u020F",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM190 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0210",
    unicode: "\u0210",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288zM394 990l-101 180h120l66 -180h-85z M172 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0211",
    unicode: "\u0211",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108zM321 690l-101 180h120l66 -180h-85zM99 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0212",
    unicode: "\u0212",
    horizAdvX: 780,
    d: "M129 0v900h226q85 0 146 -34t94.5 -89.5t33.5 -121.5q0 -49 -19 -92.5t-54 -76t-84 -51.5l302 -435h-133l-286 414h-112v-414h-114zM243 510h112q58 0 94.5 21.5t54 55t17.5 68.5q0 42 -20.5 74.5t-58 50.5t-87.5 18h-112v-288zM145 975q0 50 24 89.5t65 62t91 22.5 t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0213",
    unicode: "\u0213",
    horizAdvX: 450,
    d: "M96 0v600h100v-110q32 53 85 84.5t126 31.5l27 -108q-10 3 -21.5 4.5t-22.5 1.5q-56 0 -98 -24t-65 -70t-23 -112v-298h-108zM72 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0214",
    unicode: "\u0214",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM469 990l-101 180h120l66 -180h-85zM247 990l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0215",
    unicode: "\u0215",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM429 690l-101 180h120l66 -180h-85zM207 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0216",
    unicode: "\u0216",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM220 975q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88 q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0217",
    unicode: "\u0217",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM180 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27 t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 660,
    d: "M320 -12q-53 0 -100 15t-84 40t-63 55l33 138q19 -37 50 -70.5t73.5 -54.5t94.5 -21q48 0 85 20.5t58 56t21 79.5q0 48 -23 79t-52 49t-46 26l-110 56q-26 14 -64.5 39t-67.5 69t-29 114q0 51 18 94t51.5 74t79 48.5t100.5 17.5q72 0 127 -25.5t86 -52.5l-33 -138 q-16 28 -44 54.5t-64 44t-77 17.5q-40 0 -69.5 -16.5t-46 -44t-16.5 -62.5q0 -40 18.5 -66t42 -41t38.5 -23l112 -56q20 -10 50.5 -28t60.5 -47.5t50 -72t20 -102.5q0 -77 -36.5 -137t-99.5 -94t-144 -34zM184 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5 h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 510,
    d: "M251 -12q-46 0 -98.5 17.5t-90.5 58.5l30 118q28 -47 72 -74.5t94 -27.5q48 0 72 23.5t24 57.5q0 39 -25.5 57t-45.5 25l-81 31q-22 9 -53 26.5t-54 50.5t-23 86q0 48 23 88t65 63.5t99 23.5q45 0 94 -16t83 -54l-30 -118q-16 29 -40 50.5t-52 33.5t-58 12 q-41 0 -64.5 -23t-23.5 -53q0 -24 16 -43t48 -31l81 -31q22 -8 54.5 -26t57.5 -52t25 -92q0 -54 -26 -94.5t-70.5 -63.5t-102.5 -23zM117 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 690,
    d: "M288 0v798h-240v102h594v-102h-240v-798h-114zM207 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 450,
    d: "M166 0v510h-136v90h139v200h102v-200h149v-90h-146v-510h-108zM82 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022A",
    unicode: "\u022A",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM359 1221v78h342v-78h-342zM410 1011q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25 t-35.5 -9.5zM650 1011q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022B",
    unicode: "\u022B",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM199 921v78h342v-78h-342zM250 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM490 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5 q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022C",
    unicode: "\u022C",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM364 998l-29 82q19 36 47 54.5t63 18.5q31 0 58.5 -12t54 -24.5t52.5 -12.5q30 0 51.5 18.5t34.5 50.5l29 -82q-18 -36 -46 -54.5t-64 -18.5q-30 0 -58 12t-54 24t-52 12 q-59 0 -87 -68zM359 1221v78h342v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni022D",
    unicode: "\u022D",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM204 698l-29 82q19 36 47 54.5t63 18.5q31 0 58.5 -12t54 -24.5t52.5 -12.5q30 0 51.5 18.5t34.5 50.5l29 -82q-18 -36 -46 -54.5t-64 -18.5q-30 0 -58 12t-54 24t-52 12q-59 0 -87 -68zM199 921v78h342v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0230",
    unicode: "\u0230",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 1011q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM359 1221v78h342 v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0231",
    unicode: "\u0231",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM370 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM199 921v78h342v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0232",
    unicode: "\u0232",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM169 1038v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0233",
    unicode: "\u0233",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM152 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0237",
    unicode: "\u0237",
    horizAdvX: 300,
    d: "M31 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0259",
    unicode: "\u0259",
    horizAdvX: 710,
    d: "M351 -12q-83 0 -152 39.5t-110 107t-41 151.5v44h392q26 0 53 -2t53 -6q-7 54 -37.5 96.5t-77.5 67t-104 24.5t-106 -26t-79 -69l-30 123q44 35 99.5 54.5t116.5 19.5q71 0 131 -24.5t104 -67.5t68.5 -101t24.5 -125q0 -64 -23.5 -119.5t-65.5 -97.5t-97.5 -65.5 t-118.5 -23.5zM351 84q49 0 90 22.5t69.5 60t38.5 82.5q-27 -4 -54.5 -6.5t-54.5 -2.5h-199q-22 0 -43.5 1.5t-43.5 3.5q10 -46 38.5 -82.5t70 -57.5t88.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0292",
    unicode: "\u0292",
    horizAdvX: 660,
    d: "M302 -312q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 102.5 27.5t72.5 74t27 102.5t-27 102.5t-73 74t-102 27.5q-28 0 -52 -7t-43 -18l-2 2l171 329h-278v96h444v-2l-169 -313q50 -10 93.5 -35.5t76 -64t51 -87t18.5 -104.5 q0 -64 -24 -120t-67 -97.5t-99 -65t-120 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 720,
    d: "M171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 720,
    d: "M359 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 720,
    d: "M360 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 720,
    d: "M360 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 720,
    d: "M360 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM360 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 720,
    d: "M418 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75h100q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 720,
    d: "M176 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 720,
    d: "M378 690l66 180h120l-101 -180h-85zM156 690l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb",
    unicode: "\u0300",
    horizAdvX: 0,
    d: "M377 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb",
    unicode: "\u0301",
    horizAdvX: 0,
    d: "M252 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0302",
    unicode: "\u0302",
    horizAdvX: 0,
    d: "M171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb",
    unicode: "\u0303",
    horizAdvX: 0,
    d: "M176 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304",
    unicode: "\u0304",
    horizAdvX: 0,
    d: "M183 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0306",
    unicode: "\u0306",
    horizAdvX: 0,
    d: "M360 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307",
    unicode: "\u0307",
    horizAdvX: 0,
    d: "M360 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308",
    unicode: "\u0308",
    horizAdvX: 0,
    d: "M240 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM480 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5 q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb",
    unicode: "\u0309",
    horizAdvX: 0,
    d: "M328 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A",
    unicode: "\u030A",
    horizAdvX: 0,
    d: "M360 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM360 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030B",
    unicode: "\u030B",
    horizAdvX: 0,
    d: "M378 690l66 180h120l-101 -180h-85zM156 690l66 180h120l-101 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C",
    unicode: "\u030C",
    horizAdvX: 0,
    d: "M359 681l-188 219h114q21 -21 38 -43.5t39 -53.5q22 31 39 53.5t38 43.5h110l-188 -219h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 0,
    d: "M479 690l-101 180h120l66 -180h-85zM257 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 0,
    d: "M180 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0312",
    unicode: "\u0312",
    horizAdvX: 0,
    d: "M308 720q5 59 24.5 111.5t49.5 98.5h116q-34 -42 -57.5 -94t-28.5 -116h-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni031B",
    unicode: "\u031B",
    horizAdvX: 0,
    d: "M316 398q-27 0 -51.5 9t-44.5 26v96q13 -26 33.5 -39.5t44.5 -13.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb",
    unicode: "\u0323",
    horizAdvX: 0,
    d: "M360 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0324",
    unicode: "\u0324",
    horizAdvX: 0,
    d: "M480 -249q-19 0 -35 9t-25 25t-9 35t9 34.5t25 25t35 9.5t34.5 -9.5t25 -25t9.5 -34.5t-9.5 -35t-25 -25t-34.5 -9zM240 -249q-19 0 -35 9t-25 25t-9 35t9 34.5t25 25t35 9.5t34.5 -9.5t25 -25t9.5 -34.5t-9.5 -35t-25 -25t-34.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0326",
    unicode: "\u0326",
    horizAdvX: 0,
    d: "M222 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0327",
    unicode: "\u0327",
    horizAdvX: 0,
    d: "M204 -180l178 180h108l-143 -180h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0328",
    unicode: "\u0328",
    horizAdvX: 0,
    d: "M418 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75h100q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5t62.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni032E",
    unicode: "\u032E",
    horizAdvX: 0,
    d: "M360 -249q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0331",
    unicode: "\u0331",
    horizAdvX: 0,
    d: "M210 -222v84h300v-84h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0335",
    unicode: "\u0335",
    horizAdvX: 0,
    d: "M80 266v68h380v-68h-380z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0336",
    unicode: "\u0336",
    horizAdvX: 0,
    d: "M30 408v84h740v-84h-740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 720,
    d: "M96 0v600h528v-600h-108v498h-312v-498h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0E3F",
    unicode: "\u0E3F",
    horizAdvX: 750,
    d: "M328 -120v120h-202v900h202v90h84v-92q73 -7 116 -41.5t62 -79.5t19 -85q0 -49 -22.5 -89.5t-60.5 -66.5q49 -22 85.5 -59t57.5 -85.5t21 -104.5q0 -51 -18 -99.5t-53 -88.5t-87 -66t-120 -32v-121h-84zM240 102h130q74 0 119 29t66 73t21 87q0 42 -20 86t-65 73.5 t-121 29.5h-130v-378zM240 576h129q40 0 69.5 12.5t46 37.5t16.5 60q0 37 -16.5 61.5t-45 37.5t-66.5 13h-133v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1200,
    d: "M358 -30l-346 930h116l204 -540q11 -28 18 -53.5t15 -60.5q8 35 15.5 60.5t17.5 53.5l205 570h2l204 -570q9 -25 17.5 -50.5t15.5 -63.5q8 38 16 63.5t18 50.5l204 540h108l-345 -930h-2l-207 584q-9 26 -17 50.5t-16 62.5q-8 -38 -16 -62.5t-17 -50.5l-208 -584h-2z M550 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 1000,
    d: "M314 -30l-302 630h123l121 -260q17 -37 32.5 -72t30.5 -88q16 52 32.5 88t31.5 72l120 288h2l119 -288q15 -37 31 -72t31 -88q15 53 31 88.5t33 71.5l123 260h115l-302 -630h-2l-121 268q-16 36 -31.5 71.5t-31.5 85.5q-15 -50 -31 -85.5t-33 -71.5l-120 -268h-2z M459 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1200,
    d: "M358 -30l-346 930h116l204 -540q11 -28 18 -53.5t15 -60.5q8 35 15.5 60.5t17.5 53.5l205 570h2l204 -570q9 -25 17.5 -50.5t15.5 -63.5q8 38 16 63.5t18 50.5l204 540h108l-345 -930h-2l-207 584q-9 26 -17 50.5t-16 62.5q-8 -38 -16 -62.5t-17 -50.5l-208 -584h-2z M550 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 1000,
    d: "M314 -30l-302 630h123l121 -260q17 -37 32.5 -72t30.5 -88q16 52 32.5 88t31.5 72l120 288h2l119 -288q15 -37 31 -72t31 -88q15 53 31 88.5t33 71.5l123 260h115l-302 -630h-2l-121 268q-16 36 -31.5 71.5t-31.5 85.5q-15 -50 -31 -85.5t-33 -71.5l-120 -268h-2z M458 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1200,
    d: "M358 -30l-346 930h116l204 -540q11 -28 18 -53.5t15 -60.5q8 35 15.5 60.5t17.5 53.5l205 570h2l204 -570q9 -25 17.5 -50.5t15.5 -63.5q8 38 16 63.5t18 50.5l204 540h108l-345 -930h-2l-207 584q-9 26 -17 50.5t-16 62.5q-8 -38 -16 -62.5t-17 -50.5l-208 -584h-2z M760 918q-31 0 -51.5 20.5t-20.5 51.5t20.5 51.5t51.5 20.5t51.5 -20.5t20.5 -51.5t-20.5 -51.5t-51.5 -20.5zM448 918q-31 0 -51.5 20.5t-20.5 51.5t20.5 51.5t51.5 20.5t51.5 -20.5t20.5 -51.5t-20.5 -51.5t-51.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 1000,
    d: "M314 -30l-302 630h123l121 -260q17 -37 32.5 -72t30.5 -88q16 52 32.5 88t31.5 72l120 288h2l119 -288q15 -37 31 -72t31 -88q15 53 31 88.5t33 71.5l123 260h115l-302 -630h-2l-121 268q-16 36 -31.5 71.5t-31.5 85.5q-15 -50 -31 -85.5t-33 -71.5l-120 -268h-2z M384 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM624 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5 q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1E9E",
    unicode: "\u1E9E",
    horizAdvX: 970,
    d: "M600 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 102.5 27.5t72.5 73.5t27 103q0 56 -27 102.5t-73 74t-102 27.5q-28 0 -52 -7t-44 -18l-1 1l171 330h-434v-804h-114v900h714v-1l-169 -314q50 -10 93.5 -36t76 -64.5t51 -86.5 t18.5 -104q0 -64 -24 -120t-67 -97.5t-99 -65t-120 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA0",
    unicode: "\u1EA0",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5 t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1",
    unicode: "\u1EA1",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA2",
    unicode: "\u1EA2",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM368 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5 q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3",
    unicode: "\u1EA3",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM339 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA4",
    unicode: "\u1EA4",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM532 1119l76 150h112l-104 -150h-84zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5 h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5",
    unicode: "\u1EA5",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM503 819l76 150h112l-104 -150h-84zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA6",
    unicode: "\u1EA6",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM606 1119l-104 150h112l76 -150h-84zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5 h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7",
    unicode: "\u1EA7",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM577 819l-104 150h112l76 -150h-84zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA8",
    unicode: "\u1EA8",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM568 1119q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28 t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9",
    unicode: "\u1EA9",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM539 819q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5 t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAA",
    unicode: "\u1EAA",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM211 990l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM252 1192l-26 73q17 32 42 49 t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB",
    unicode: "\u1EAB",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM182 690l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM223 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5 t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAC",
    unicode: "\u1EAC",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5 t-25.5 -26t-37 -9.5zM211 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD",
    unicode: "\u1EAD",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM182 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5 q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAE",
    unicode: "\u1EAE",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 975q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z M346 1179l76 150h112l-104 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF",
    unicode: "\u1EAF",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5zM317 879l76 150h112l-104 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB0",
    unicode: "\u1EB0",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 975q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM370 1179 l-104 150h112l76 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1",
    unicode: "\u1EB1",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM341 879l-104 150h112l76 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB2",
    unicode: "\u1EB2",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 975q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM358 1179 q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3",
    unicode: "\u1EB3",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM329 879q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23 t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB4",
    unicode: "\u1EB4",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 975q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z M252 1192l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5",
    unicode: "\u1EB5",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5zM223 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73 q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB6",
    unicode: "\u1EB6",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-121l-106 266h-315l-107 -266h-115zM278 362h239l-71 178q-13 34 -25 67t-24 79q-12 -46 -23 -78.5t-25 -67.5zM400 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5 t-25.5 -26t-37 -9.5zM400 975q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7",
    unicode: "\u1EB7",
    horizAdvX: 760,
    d: "M353 -8q-62 0 -116 24t-95.5 66.5t-64.5 98t-23 119.5t23 119.5t64.5 98t95.5 66.5t116 24t116.5 -23t94.5 -64v79h100v-600h-100v79q-40 -40 -94.5 -63.5t-116.5 -23.5zM367 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76 t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5zM371 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM371 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27 t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB8",
    unicode: "\u1EB8",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM348 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB9",
    unicode: "\u1EB9",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM358 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBA",
    unicode: "\u1EBA",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM316 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBB",
    unicode: "\u1EBB",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM326 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5 q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBC",
    unicode: "\u1EBC",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM151 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBD",
    unicode: "\u1EBD",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM174 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5 t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBE",
    unicode: "\u1EBE",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM480 1119l76 150h112l-104 -150h-84zM159 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EBF",
    unicode: "\u1EBF",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM490 819l76 150h112l-104 -150h-84zM169 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5 t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC0",
    unicode: "\u1EC0",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM554 1119l-104 150h112l76 -150h-84zM159 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC1",
    unicode: "\u1EC1",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM564 819l-104 150h112l76 -150h-84zM169 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5 t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC2",
    unicode: "\u1EC2",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM516 1119q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM159 990l188 219h2l188 -219h-114 q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC3",
    unicode: "\u1EC3",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM526 819q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28 t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM169 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC4",
    unicode: "\u1EC4",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM159 990l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM200 1192l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73 q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC5",
    unicode: "\u1EC5",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM169 690l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM210 892l-26 73q17 32 42 49 t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC6",
    unicode: "\u1EC6",
    horizAdvX: 630,
    d: "M126 0v900h444v-102h-330v-192h260v-102h-260v-402h330v-102h-444zM348 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM159 990l188 219h2l188 -219h-114q-21 21 -38 43.5 t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC7",
    unicode: "\u1EC7",
    horizAdvX: 710,
    d: "M382 -12q-71 0 -131 24.5t-104 67.5t-68.5 101t-24.5 125q0 64 23.5 119.5t65.5 97.5t97.5 65.5t118.5 23.5q83 0 152 -39.5t110 -106.5t41 -152v-44h-392q-26 0 -53 2t-53 6q7 -53 37.5 -96t77.5 -67.5t104 -24.5t106 26t79 69l30 -123q-43 -35 -98.5 -54.5 t-117.5 -19.5zM161 351q27 5 54.5 7t54.5 2h199q22 0 43.5 -1.5t43.5 -3.5q-9 47 -38 83t-70 57t-89 21q-49 0 -90.5 -22.5t-69.5 -59.5t-38 -83zM358 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM169 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC8",
    unicode: "\u1EC8",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM159 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EC9",
    unicode: "\u1EC9",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM118 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECA",
    unicode: "\u1ECA",
    horizAdvX: 390,
    d: "M138 0v900h114v-900h-114zM195 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECB",
    unicode: "\u1ECB",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM150 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5 t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECC",
    unicode: "\u1ECC",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECD",
    unicode: "\u1ECD",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM370 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECE",
    unicode: "\u1ECE",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM494 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5 q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ECF",
    unicode: "\u1ECF",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM338 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED0",
    unicode: "\u1ED0",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM662 1119l76 150h112l-104 -150h-84zM341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED1",
    unicode: "\u1ED1",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM502 819l76 150h112l-104 -150h-84zM181 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED2",
    unicode: "\u1ED2",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM736 1119l-104 150h112l76 -150h-84zM341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED3",
    unicode: "\u1ED3",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM576 819l-104 150h112l76 -150h-84zM181 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED4",
    unicode: "\u1ED4",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM698 1119q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90z M341 990l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED5",
    unicode: "\u1ED5",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM538 819q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM181 690l188 219h2l188 -219h-114q-21 21 -38 43.5 t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED6",
    unicode: "\u1ED6",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM341 990l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM382 1192l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11 q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED7",
    unicode: "\u1ED7",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM181 690l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM222 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5 t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED8",
    unicode: "\u1ED8",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM341 990l188 219h2 l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1ED9",
    unicode: "\u1ED9",
    horizAdvX: 740,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24t123 -24t100.5 -67t68 -99.5t24.5 -121.5t-24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5 t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM370 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM181 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5 q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDA",
    unicode: "\u1EDA",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM476 990l144 180h144l-180 -180h-108z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDB",
    unicode: "\u1EDB",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM324 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDC",
    unicode: "\u1EDC",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM476 990l-180 180h144l144 -180h-108z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDD",
    unicode: "\u1EDD",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM325 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDE",
    unicode: "\u1EDE",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM494 990q25 29 38.5 51.5t13.5 41.5 q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EDF",
    unicode: "\u1EDF",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM338 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25 l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE0",
    unicode: "\u1EE0",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM333 993l-23 96q23 38 53.5 57 t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE1",
    unicode: "\u1EE1",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM186 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5 q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE2",
    unicode: "\u1EE2",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149 -99.5q16 6 26.5 18.5t16 30t5.5 37.5q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -39 -11.5 -70t-30.5 -52.5t-44 -33.5q38 -55 59 -122 t21 -140q0 -97 -36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 -252q-20 0 -36.5 9.5t-26 26 t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE3",
    unicode: "\u1EE3",
    horizAdvX: 770,
    d: "M370 -12q-66 0 -123 24t-100.5 67t-68 99.5t-24.5 121.5t24.5 121.5t68 99.5t100.5 67t123 24q77 0 143 -33.5t109 -89.5q15 11 24.5 30t9.5 49q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -38 -10.5 -68t-29 -51.5t-42.5 -34.5q11 -26 16.5 -55t5.5 -59 q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM370 90q58 0 105 28.5t75 76t28 105.5t-28 105.5t-75 76t-105 28.5t-105 -28.5t-75 -76t-28 -105.5t28 -105.5t75 -76t105 -28.5zM370 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5 q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE4",
    unicode: "\u1EE4",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM400 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5 q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE5",
    unicode: "\u1EE5",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM360 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5 t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE6",
    unicode: "\u1EE6",
    horizAdvX: 800,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h114v-613q0 -59 23.5 -103.5t64 -69t92.5 -24.5t92.5 24.5t64 68t23.5 100.5v617h110v-613q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM364 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5 q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE7",
    unicode: "\u1EE7",
    horizAdvX: 720,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -71 42.5 -125.5t119.5 -54.5q42 0 79 20.5t60 60t23 96.5v333h108v-600h-100v97q-33 -53 -85.5 -81t-113.5 -28zM328 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25 l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE8",
    unicode: "\u1EE8",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM346 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EE9",
    unicode: "\u1EE9",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28zM314 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEA",
    unicode: "\u1EEA",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM346 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEB",
    unicode: "\u1EEB",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28zM315 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEC",
    unicode: "\u1EEC",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM364 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EED",
    unicode: "\u1EED",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28zM328 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEE",
    unicode: "\u1EEE",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM203 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20 t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EEF",
    unicode: "\u1EEF",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28zM176 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF0",
    unicode: "\u1EF0",
    horizAdvX: 920,
    d: "M400 -12q-85 0 -151 37.5t-103.5 104t-37.5 153.5v617h115v-613q0 -59 23 -103.5t63 -69t91 -24.5t91 24.5t63 68t23 100.5v617h109v-115q8 -4 17 -6.5t19 -2.5q25 0 42.5 12t26.5 33t9 47q0 18 -5 42.5t-19 49.5h96q14 -24 19 -47t5 -45q0 -54 -21 -92t-55 -58t-74 -20 q-14 0 -27.5 2.5t-26.5 7.5v-421q0 -88 -37.5 -155.5t-103 -105.5t-151.5 -38zM400 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF1",
    unicode: "\u1EF1",
    horizAdvX: 840,
    d: "M325 -12q-63 0 -118 31.5t-89 91.5t-34 144v345h108v-330q0 -48 19 -89t55 -66t86 -25q43 0 80.5 20.5t60.5 60t23 96.5v333h102v-118q7 -3 15 -4.5t15 -1.5q20 0 38 9.5t29 30t11 52.5q0 18 -5 42.5t-19 49.5h90q14 -24 19 -47t5 -45q0 -55 -21 -93t-55 -57.5t-74 -19.5 q-10 0 -21 1.5t-21 4.5v-404h-100v97q-33 -53 -85.5 -81t-113.5 -28zM360 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM292 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM284 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF4",
    unicode: "\u1EF4",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM346 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26 t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF5",
    unicode: "\u1EF5",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM443 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26 t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF6",
    unicode: "\u1EF6",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM310 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5 t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF7",
    unicode: "\u1EF7",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM297 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5q53 0 91.5 -30.5t38.5 -83.5 q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF8",
    unicode: "\u1EF8",
    horizAdvX: 690,
    d: "M288 0v435l-270 465h132l148 -262q14 -25 26.5 -49.5t25.5 -56.5q13 32 26 56.5t27 49.5l149 262h120l-270 -465v-435h-114zM149 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5 q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EF9",
    unicode: "\u1EF9",
    horizAdvX: 650,
    d: "M71 -300l195 388l-254 512h122l128 -260q17 -35 33 -69t32 -82q17 48 32.5 82.5t33.5 68.5l130 260h115l-450 -900h-117zM145 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5t-71 -20.5 q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2002",
    unicode: "\u2002",
    horizAdvX: 720
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2003",
    unicode: "\u2003",
    horizAdvX: 1440
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2004",
    unicode: "\u2004"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2005",
    unicode: "\u2005",
    horizAdvX: 360
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2006",
    unicode: "\u2006",
    horizAdvX: 240
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2007",
    unicode: "\u2007",
    horizAdvX: 750
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2008",
    unicode: "\u2008",
    horizAdvX: 270
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2009",
    unicode: "\u2009",
    horizAdvX: 120
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni200A",
    unicode: "\u200A",
    horizAdvX: 60
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 360,
    d: "M30 252v96h300v-96h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 720,
    d: "M60 252v96h600v-96h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1440,
    d: "M60 249v102h1320v-102h-1320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2016",
    unicode: "\u2016",
    d: "M327 -180v1140h66v-1140h-66zM87 -180v1140h66v-1140h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 270,
    d: "M56 600q0 86 23.5 161t64.5 139h120q-30 -37 -52.5 -82t-35 -99.5t-12.5 -118.5h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 270,
    d: "M6 600q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 270,
    d: "M6 -150q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 540,
    d: "M56 600q0 86 23.5 161t64.5 139h120q-30 -37 -52.5 -82t-35 -99.5t-12.5 -118.5h-108zM326 600q0 86 23.5 161t64.5 139h120q-30 -37 -52.5 -82t-35 -99.5t-12.5 -118.5h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 540,
    d: "M6 600q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120zM276 600q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 540,
    d: "M6 -150q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120zM276 -150q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 600,
    d: "M246 0l6 587l-180 -2v90l181 -3l-7 228h108l-7 -228l181 3v-90l-180 2l6 -587h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 600,
    d: "M246 0l7 228l-181 -3v90l180 -2l-3 137l3 137l-180 -2v90l181 -3l-7 228h108l-7 -228l181 3v-90l-180 2l3 -137l-3 -137l180 2v-90l-181 3l7 -228h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    d: "M240 294q-43 0 -78.5 21t-56.5 56.5t-21 78.5t21 78.5t56.5 56.5t78.5 21t78.5 -21t56.5 -56.5t21 -78.5t-21 -78.5t-56.5 -56.5t-78.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1440,
    d: "M1200 -12q-21 0 -38 10t-27 27t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10zM240 -12q-21 0 -38 10t-27 27t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10zM720 -12q-21 0 -38 10 t-27 27t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1560,
    d: "M240 408q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 488q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26zM186 0l618 900h90l-618 -900h-90zM840 -12q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM840 68q37 0 59 26 t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26zM1320 -12q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91 t-36 -81.5t-60 -58t-84 -21.5zM1320 68q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minute",
    unicode: "\u2032",
    horizAdvX: 270,
    d: "M42 570l119 330h144l-215 -330h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "second",
    unicode: "\u2033",
    horizAdvX: 540,
    d: "M42 570l119 330h144l-215 -330h-48zM312 570l119 330h144l-215 -330h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 360,
    d: "M198 120l-192 180l192 180h132l-192 -180l192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 360,
    d: "M30 120l192 180l-192 180h132l192 -180l-192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2042",
    unicode: "\u2042",
    horizAdvX: 1620,
    d: "M189 -433l-77 57l132 160l-202 52l30 91l193 -76l-13 209h96l-13 -209l193 76l30 -91l-202 -52l132 -160l-77 -57l-111 175zM699 407l-77 57l132 160l-202 52l30 91l193 -76l-13 209h96l-13 -209l193 76l30 -91l-202 -52l132 -160l-77 -57l-111 175zM1209 -433l-77 57 l132 160l-202 52l30 91l193 -76l-13 209h96l-13 -209l193 76l30 -91l-202 -52l132 -160l-77 -57l-111 175z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 120,
    d: "M-294 0l618 900h90l-618 -900h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2052",
    unicode: "\u2052",
    horizAdvX: 750,
    d: "M106 0l454 900h84l-454 -900h-84zM165 582q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5zM585 162q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5 q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2070",
    unicode: "\u2070",
    d: "M240 648q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 728q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2074",
    unicode: "\u2074",
    d: "M272 660v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2075",
    unicode: "\u2075",
    d: "M220 648q-49 0 -90.5 22t-67.5 59l48 91q6 -41 36.5 -66.5t71.5 -25.5q29 0 51 12t34.5 33.5t12.5 47.5q0 27 -12.5 48t-34.5 33.5t-51 12.5q-31 0 -52.5 -12.5t-38.5 -35.5h-2v273h238v-80h-168v-77q8 2 17.5 3t19.5 1q53 0 91 -23.5t58.5 -61t20.5 -81.5 q0 -47 -24 -86.5t-65 -63t-93 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2076",
    unicode: "\u2076",
    d: "M240 648q-50 0 -91.5 23t-66 62.5t-24.5 88.5q0 22 5.5 43.5t15.5 40.5l125 234h90l-85 -157q11 5 22.5 6.5t21.5 1.5q46 0 84.5 -22t61.5 -59.5t23 -86.5t-24.5 -89t-66 -63t-91.5 -23zM240 728q27 0 48.5 13t34.5 34.5t13 47.5q0 27 -13 49t-34.5 35t-48.5 13 t-48.5 -13t-34.5 -35t-13 -49q0 -26 13 -47.5t34.5 -34.5t48.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2077",
    unicode: "\u2077",
    d: "M102 660l200 400h-216v80h349v-2l-237 -478h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2078",
    unicode: "\u2078",
    d: "M240 648q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM240 728 q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM240 972q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2079",
    unicode: "\u2079",
    d: "M184 660l89 164q-11 -5 -23 -7t-23 -2q-44 0 -81.5 21.5t-59.5 59t-22 84.5q0 49 24 87.5t64 61.5t88 23q49 0 88.5 -22.5t63.5 -61.5t24 -87q0 -21 -5.5 -42.5t-14.5 -39.5l-120 -239h-92zM240 892q26 0 46 12.5t32 33t12 45.5t-12 45t-32 32t-46 12q-25 0 -45.5 -12 t-32.5 -32t-12 -45t12 -45.5t32.5 -33t45.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus.superior",
    unicode: "\u207A",
    d: "M201 695v169h-166v72h166v169h77v-169h167v-72h-167v-169h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus.superior",
    unicode: "\u207B",
    d: "M54 862v76h372v-76h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal.superior",
    unicode: "\u207C",
    d: "M54 940v73h372v-73h-372zM54 787v73h372v-73h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.superior",
    unicode: "\u207D",
    horizAdvX: 320,
    d: "M211 540q-49 80 -76 171.5t-27 189.5q0 97 27 188t76 171h95q-35 -50 -60 -107t-38.5 -120t-13.5 -132t13.5 -133t38.5 -121t60 -107h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.superior",
    unicode: "\u207E",
    horizAdvX: 320,
    d: "M14 540q36 51 61 108.5t38 121t13 130.5q0 68 -13 131t-38 120.5t-61 108.5h94q50 -80 77 -171t27 -189q0 -97 -27 -188.5t-77 -171.5h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2080",
    unicode: "\u2080",
    d: "M240 -252q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 -172q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2081",
    unicode: "\u2081",
    d: "M228 -240v371l-114 -57v84l202 102h2v-500h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2082",
    unicode: "\u2082",
    d: "M70 -240v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2083",
    unicode: "\u2083",
    d: "M219 -252q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2084",
    unicode: "\u2084",
    d: "M272 -240v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2085",
    unicode: "\u2085",
    d: "M220 -252q-49 0 -90.5 22t-67.5 59l48 91q6 -41 36.5 -66.5t71.5 -25.5q29 0 51 12t34.5 33.5t12.5 47.5q0 27 -12.5 48t-34.5 33.5t-51 12.5q-31 0 -52.5 -12.5t-38.5 -35.5h-2v273h238v-80h-168v-77q8 2 17.5 3t19.5 1q53 0 91 -23.5t58.5 -61t20.5 -81.5 q0 -47 -24 -86.5t-65 -63t-93 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2086",
    unicode: "\u2086",
    d: "M240 -252q-50 0 -91.5 23t-66 62.5t-24.5 88.5q0 22 5.5 43.5t15.5 40.5l125 234h90l-85 -157q11 5 22.5 6.5t21.5 1.5q46 0 84.5 -22t61.5 -59.5t23 -86.5t-24.5 -89t-66 -63t-91.5 -23zM240 -172q27 0 48.5 13t34.5 34.5t13 47.5q0 27 -13 49t-34.5 35t-48.5 13 t-48.5 -13t-34.5 -35t-13 -49q0 -26 13 -47.5t34.5 -34.5t48.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2087",
    unicode: "\u2087",
    d: "M102 -240l200 400h-216v80h349v-2l-237 -478h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2088",
    unicode: "\u2088",
    d: "M240 -252q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM240 -172 q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM240 72q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2089",
    unicode: "\u2089",
    d: "M184 -240l89 164q-11 -5 -23 -7t-23 -2q-44 0 -81.5 21.5t-59.5 59t-22 84.5q0 49 24 87.5t64 61.5t88 23q49 0 88.5 -22.5t63.5 -61.5t24 -87q0 -21 -5.5 -42.5t-14.5 -39.5l-120 -239h-92zM240 -8q26 0 46 12.5t32 33t12 45.5t-12 45t-32 32t-46 12q-25 0 -45.5 -12 t-32.5 -32t-12 -45t12 -45.5t32.5 -33t45.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus.inferior",
    unicode: "\u208A",
    d: "M201 -205v169h-166v72h166v169h77v-169h167v-72h-167v-169h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus.inferior",
    unicode: "\u208B",
    d: "M54 -38v76h372v-76h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal.inferior",
    unicode: "\u208C",
    d: "M54 40v73h372v-73h-372zM54 -113v73h372v-73h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.inferior",
    unicode: "\u208D",
    horizAdvX: 320,
    d: "M151 -360q-49 80 -76 171.5t-27 189.5q0 97 27 188t76 171h95q-35 -50 -60 -107t-38.5 -120t-13.5 -132t13.5 -133t38.5 -121t60 -107h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.inferior",
    unicode: "\u208E",
    horizAdvX: 320,
    d: "M74 -360q36 51 61 108.5t38 121t13 130.5q0 68 -13 131t-38 120.5t-61 108.5h94q50 -80 77 -171t27 -189q0 -97 -27 -188.5t-77 -171.5h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 750,
    d: "M248 -120l14 166q-43 31 -76 75t-56 97t-34.5 112t-11.5 120q0 68 14.5 132.5t42 121.5t67.5 102t91 72l9 112h84l-6 -81q23 4 48 4.5t48 -1.5l6 78h84l-8 -100q30 -13 57 -31.5t50 -41.5l-34 -138q-31 58 -81 94.5t-116 36.5q-59 0 -105 -31t-77.5 -83t-48 -116 t-16.5 -130t16.5 -130t48 -116t77.5 -83t105 -31q67 0 116.5 37t80.5 95l34 -139q-31 -31 -68.5 -53t-81.5 -33l-9 -117h-84l8 107q-25 1 -48.5 5.5t-45.5 11.5l-10 -124h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 750,
    d: "M622 -30l-394 620v-590h-102v318h-96v84h96v96h-96v84h96v348h2l394 -620v590h102v-318h96v-84h-96v-96h96v-84h-96v-348h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A8",
    unicode: "\u20A8",
    horizAdvX: 750,
    d: "M70 0v900h163q67 0 109.5 -34t63.5 -89.5t21 -122.5q0 -46 -10 -87.5t-30.5 -74.5t-53.5 -54l123 -438h-98l-117 410h-75v-410h-96zM166 503h62q33 0 56 17.5t35 51t12 81.5q0 49 -12 82.5t-35 51t-56 17.5h-62v-301zM594 -13q-31 0 -63 18t-55 57l31 122 q14 -46 36.5 -72t46.5 -26q16 0 26 9t15 24.5t5 33.5q0 31 -15.5 55.5t-38.5 48t-46.5 50t-39 61t-15.5 80.5q0 33 8 63t23.5 53t37 36t48.5 13q19 0 39.5 -7.5t39 -23t31.5 -39.5l-30 -120q-13 44 -33.5 67.5t-41.5 23.5q-19 0 -30.5 -19t-11.5 -43q0 -28 15.5 -51 t38.5 -45.5t46.5 -49.5t39 -62.5t15.5 -85.5t-16 -89t-43.5 -60.5t-62.5 -21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 750,
    d: "M228 -31l-81 349h-117v84h97l-23 96h-74v84h54l-75 318h94l110 -462q9 -38 13 -77t11 -94q6 55 10.5 94t13.5 77l115 492h2l116 -492q8 -36 13.5 -75t11.5 -96q7 57 11.5 96t12.5 75l109 462h89l-75 -318h54v-84h-74l-23 -96h97v-84h-117l-81 -349h-2l-120 514 q-6 26 -12 53.5t-12 67.5q-7 -40 -13 -67t-12 -53l-121 -515h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AA",
    unicode: "\u20AA",
    horizAdvX: 750,
    d: "M450 0q-58 0 -106 26t-76 73.5t-28 110.5v510h90v-500q0 -61 38.5 -98.5t97.5 -37.5h134v816h90v-900h-240zM60 0v900h240q59 0 106.5 -26t75.5 -73.5t28 -110.5v-510h-90v500q0 61 -38.5 98.5t-97.5 37.5h-134v-816h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dong",
    unicode: "\u20AB",
    horizAdvX: 750,
    d: "M353 112q-55 0 -104 21.5t-86 60t-58 89t-21 107.5q0 58 21 108.5t58 88.5t86 59.5t104 21.5q56 0 104 -20.5t83 -57.5v181h-227v78h227v111h96v-111h84v-78h-84v-651h-96v70q-35 -37 -83 -57.5t-104 -20.5zM102 -42v84h546v-84h-546zM367 205q50 0 91 25t65.5 67 t24.5 93t-24.5 93t-65.5 67t-91 25t-91.5 -25t-65.5 -67t-24 -93t24 -93t65.5 -67t91.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 750,
    d: "M502 -12q-85 0 -147 45.5t-100.5 120.5t-55.5 164h-109v84h99q-1 23 -1 48.5t1 47.5h-99v84h109q17 89 55.5 164t100.5 120.5t147 45.5q58 0 104.5 -22t83.5 -60l-34 -138q-25 52 -63 85t-91 33q-52 0 -89.5 -31.5t-62 -83t-36.5 -113.5h226v-84h-237q-1 -23 -1 -48.5 t1 -47.5h237v-84h-226q12 -61 36.5 -113t62 -83.5t89.5 -31.5q53 0 91 33.5t63 85.5l34 -139q-37 -38 -83.5 -60t-104.5 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AD",
    unicode: "\u20AD",
    horizAdvX: 750,
    d: "M126 0v438h-66v84h66v378h114v-407q19 31 38 57.5t37 49.5l231 300h126l-184 -240q-26 -34 -57.5 -68.5t-67.5 -69.5h267v-84h-266q37 -34 68 -68.5t58 -69.5l230 -300h-132l-274 360q-18 23 -36.5 49t-37.5 57v-466h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20AE",
    unicode: "\u20AE",
    horizAdvX: 750,
    d: "M318 0v303l-168 -45v84l168 45v96l-168 -45v84l168 45v231h-258v102h630v-102h-258v-201l168 45v-84l-168 -45v-96l168 45v-84l-168 -45v-333h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B1",
    unicode: "\u20B1",
    horizAdvX: 750,
    d: "M126 0v468h-66v84h66v96h-66v84h66v168h183q123 0 194 -50t102 -118h85v-84h-61q3 -21 3 -48t-4 -48h62v-84h-89q-31 -65 -102 -112.5t-190 -47.5h-69v-308h-114zM240 410h63q81 0 128 28.5t67 72t20 89.5q0 48 -19.5 93.5t-66 75t-129.5 29.5h-63v-388z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B2",
    unicode: "\u20B2",
    horizAdvX: 750,
    d: "M396 -120v110q-74 10 -132 51.5t-98 105.5t-61 142.5t-21 160.5q0 83 21 161t61 142.5t98 106t132 51.5v79h84v-79q53 -7 98 -31t82 -61l-34 -138q-30 57 -78 93t-111 36q-57 0 -101.5 -31t-75 -83t-46 -116t-15.5 -130t15.5 -130t46 -116t75 -83t101.5 -31q41 0 76 12.5 t63 34.5v247h-192v96h288v-399q-39 -37 -87 -60.5t-105 -30.5v-110h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B4",
    unicode: "\u20B4",
    horizAdvX: 750,
    d: "M60 492v90h412q7 14 12.5 31.5t5.5 40.5q0 44 -21.5 79.5t-59.5 56t-88 20.5q-57 0 -106 -26t-79 -69l-30 123q44 35 99.5 54.5t116.5 19.5q81 0 144 -34t99.5 -94t36.5 -137q0 -17 -2.5 -34t-7.5 -31h98v-90h-630zM428 -12q-80 0 -143.5 34t-100 94t-36.5 137 q0 17 3 34.5t7 30.5h-98v90h630v-90h-412q-7 -13 -12.5 -31t-5.5 -41q0 -44 21.5 -79.5t59.5 -56t88 -20.5q57 0 106 26t79 69l30 -123q-43 -35 -98.5 -54.5t-117.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B5",
    unicode: "\u20B5",
    horizAdvX: 750,
    d: "M408 -120v110q-74 10 -132 51.5t-98 105.5t-61 142.5t-21 160.5q0 83 21 161t61 142.5t98 106t132 51.5v79h84v-79q53 -7 98 -31t82 -61l-34 -138q-30 57 -78 93t-111 36q-57 0 -101.5 -31t-75 -83t-46 -116t-15.5 -130t15.5 -130t46 -116t75 -83t101.5 -31 q64 0 111.5 36t77.5 94l34 -139q-37 -37 -82 -60.5t-98 -30.5v-110h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B8",
    unicode: "\u20B8",
    horizAdvX: 750,
    d: "M318 0v636h-258v90h630v-90h-258v-636h-114zM60 810v90h630v-90h-630z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 750,
    d: "M472 0l-403 450v2h222q86 0 134.5 36.5t53.5 99.5h-419v84h418q-9 59 -56.5 92.5t-130.5 33.5h-231v102h630v-84h-196q43 -24 65.5 -65.5t26.5 -78.5h104v-84h-104q-4 -65 -40.5 -116t-100 -80.5t-150.5 -29.5h-10l326 -362h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BA",
    unicode: "\u20BA",
    horizAdvX: 750,
    d: "M186 0v372l-126 -34v84l126 34v96l-126 -34v84l126 34v264h108v-236l216 58v-84l-216 -58v-96l216 58v-84l-216 -58v-314h116q51 0 93 24.5t66.5 66.5t24.5 93q0 34 -12 65t-33 55h122q12 -26 18.5 -56t6.5 -62q0 -56 -21 -105.5t-58.5 -87t-87.5 -58.5t-108 -21h-235z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BC",
    unicode: "\u20BC",
    horizAdvX: 750,
    d: "M84 0v505q0 82 31 144t85.5 99t126.5 43v169h96v-169q72 -6 126.5 -43t85.5 -99t31 -144v-505h-100v507q0 80 -40 128.5t-103 58.5v-634h-96v634q-63 -10 -103 -58.5t-40 -128.5v-507h-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BD",
    unicode: "\u20BD",
    horizAdvX: 750,
    d: "M168 0v138h-108v84h108v96h-108v84h108v498h211q89 0 150.5 -26.5t99.5 -70t55.5 -94.5t17.5 -100q0 -48 -17 -99t-55 -94.5t-100 -70.5t-151 -27h-97v-96h228v-84h-228v-138h-114zM282 420h91q81 0 128 28t67 71.5t20 89.5q0 44 -19.5 87.5t-66 72.5t-129.5 29h-91v-378 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BE",
    unicode: "\u20BE",
    horizAdvX: 750,
    d: "M84 0v90h178q-43 28 -76 68.5t-55.5 92t-34 113t-11.5 132.5q0 65 11 121.5t32 103.5t50 84t65 61v124h84v-85q23 5 48.5 6.5t47.5 -1.5v80h84v-105q48 -23 84 -65t55.5 -96.5t19.5 -117.5q0 -23 -2 -40t-5 -32h-108q5 17 7 33.5t2 35.5q0 61 -21 107.5t-59 73t-91 26.5 q-41 0 -76 -21.5t-61 -62t-40.5 -98.5t-14.5 -131q0 -90 21 -165t59.5 -129t90 -83.5t111.5 -29.5h187v-90h-582z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20BF",
    unicode: "\u20BF",
    horizAdvX: 750,
    d: "M213 -120v120h-87v900h75v90h84v-90h48h48v90h84v-103q53 -16 84.5 -49t45.5 -72t14 -74q0 -49 -22.5 -89.5t-60.5 -66.5q49 -22 85.5 -59t57.5 -85.5t21 -104.5q0 -59 -24 -114.5t-71.5 -98t-117.5 -61.5v-133h-84v120h-48h-48v-120h-84zM240 102h130q74 0 119 29t66 73 t21 87q0 42 -20 86t-65 73.5t-121 29.5h-130v-378zM240 576h129q40 0 69.5 12.5t46 37.5t16.5 60q0 37 -16.5 61.5t-45 37.5t-66.5 13h-133v-222z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2105",
    unicode: "\u2105",
    horizAdvX: 960,
    d: "M106 0l618 900h90l-618 -900h-90zM720 -12q-55 0 -100 26t-71.5 69.5t-26.5 96.5t26.5 96.5t71.5 69.5t100 26t100 -26t71.5 -69.5t26.5 -96.5t-26.5 -96.5t-71.5 -69.5t-100 -26zM720 69q32 0 57.5 15t41 40.5t15.5 55.5q0 31 -15.5 56t-41 40t-57.5 15t-58 -15t-41 -40 t-15 -56q0 -30 15 -55.5t41 -40.5t58 -15zM240 528q-55 0 -100 26t-71.5 69.5t-26.5 96.5t26.5 96.5t71.5 69.5t100 26q32 0 60.5 -9t52.5 -25l-21 -83q-15 17 -38 26.5t-51 9.5q-33 0 -59.5 -15t-42 -40t-15.5 -56q0 -30 15.5 -55.5t42 -40.5t59.5 -15q28 0 51 10t38 27 l21 -84q-24 -16 -52.5 -25t-60.5 -9z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 600,
    d: "M378 -12q-64 0 -112 27t-74 76.5t-26 116.5v123q-26 -6 -52.5 -9.5t-53.5 -3.5v90q28 0 54.5 4t51.5 11v280q0 84 26.5 144.5t72.5 92.5t103 32q50 0 88.5 -24.5t61 -70.5t22.5 -112q0 -62 -20.5 -121t-56.5 -111.5t-84.5 -95t-104.5 -71.5v-150q0 -61 31 -96.5t83 -35.5 q30 0 59 12.5t59 43.5l25 -103q-26 -24 -66.5 -36.5t-86.5 -12.5zM274 471q38 24 69 57t53.5 71.5t35 80t12.5 84.5q0 35 -10 59.5t-26.5 37.5t-38.5 13q-43 0 -69 -44t-26 -124v-235z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2116",
    unicode: "\u2116",
    horizAdvX: 1470,
    d: "M862 -30l-628 675v-645h-108v930h2l628 -675v645h108v-930h-2zM1230 108q-21 0 -38 10t-27 27t-10 38t10 38t27 27t38 10q22 0 38.5 -10t26.5 -27t10 -38t-10 -38t-26.5 -27t-38.5 -10zM1230 408q-55 0 -100 26t-71.5 69.5t-26.5 96.5t26.5 96.5t71.5 69.5t100 26 t100 -26t71.5 -69.5t26.5 -96.5t-26.5 -96.5t-71.5 -69.5t-100 -26zM1230 489q32 0 57.5 15t41 40.5t15.5 55.5q0 31 -15.5 56t-41 40t-57.5 15t-58 -15t-41 -40t-15 -56q0 -30 15 -55.5t41 -40.5t58 -15z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 840,
    d: "M396 540v390h1l191 -263l191 266h1v-393h-84v84v27t0.5 22t0.5 18q-6 -7 -13 -17t-18 -24l-80 -104l-79 103q-12 16 -20 27t-14 19q1 -9 1 -19.5v-23v-28.5v-84h-78zM138 540v282h-102v78h288v-78h-102v-282h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2126",
    unicode: "\u2126",
    horizAdvX: 1060,
    d: "M60 0v102h184q-69 87 -111 184t-42 191q0 92 34 172t94 140.5t140 94.5t171 34q92 0 171.5 -34t139.5 -94.5t94 -140.5t34 -172q0 -94 -42 -191t-111 -184h184v-102h-370l116 168q41 59 64 109.5t33 97.5t10 93q0 74 -24 137t-67.5 109t-102.5 71.5t-129 25.5t-129 -25.5 t-102.5 -71.5t-67.5 -109t-24 -137q0 -46 10 -93t33.5 -97.5t63.5 -109.5l116 -168h-370z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 1260,
    d: "M630 -102q-115 0 -216.5 43t-178 119t-120 176t-43.5 214t43.5 214t120 176t178 119t216.5 43q116 0 217 -43t177.5 -119t120 -176t43.5 -214q0 -11 -0.5 -22.5t-1.5 -22.5h-946v-203q41 -64 101 -112t133.5 -75t155.5 -27q84 0 158.5 28t135.5 78t101 116h108 q-45 -92 -121 -162.5t-173.5 -110t-208.5 -39.5zM240 495h780v203q-41 64 -101 112t-133.5 75t-155.5 27t-155.5 -27t-133.5 -75t-101 -112v-203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2153",
    unicode: "\u2153",
    horizAdvX: 1080,
    d: "M228 420v371l-114 -57v84l202 102h2v-500h-90zM166 0l618 900h90l-618 -900h-90zM819 -12q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281 v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2154",
    unicode: "\u2154",
    horizAdvX: 1080,
    d: "M70 420v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z M186 0l618 900h90l-618 -900h-90zM819 -12q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73 q0 -49 -24 -89.5t-65 -64t-94 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 1080,
    d: "M228 420v371l-114 -57v84l202 102h2v-500h-90zM186 0l618 900h90l-618 -900h-90zM840 -12q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34 q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM840 68q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM840 312q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5 q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 1080,
    d: "M219 408q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z M186 0l618 900h90l-618 -900h-90zM840 -12q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5 t-87.5 -22.5zM840 68q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM840 312q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 1080,
    d: "M220 408q-49 0 -90.5 22t-67.5 59l48 91q6 -41 36.5 -66.5t71.5 -25.5q29 0 51 12t34.5 33.5t12.5 47.5q0 27 -12.5 48t-34.5 33.5t-51 12.5q-31 0 -52.5 -12.5t-38.5 -35.5h-2v273h238v-80h-168v-77q8 2 17.5 3t19.5 1q53 0 91 -23.5t58.5 -61t20.5 -81.5 q0 -47 -24 -86.5t-65 -63t-93 -23.5zM186 0l618 900h90l-618 -900h-90zM840 -12q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58 t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM840 68q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM840 312q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5 t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 1080,
    d: "M102 420l200 400h-216v80h349v-2l-237 -478h-96zM136 0l618 900h90l-618 -900h-90zM840 -12q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34 q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM840 68q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM840 312q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5 q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dek",
    unicode: "\u218A",
    horizAdvX: 750,
    d: "M383 -12q-54 0 -102 19.5t-84.5 54.5t-57.5 82t-21 101q0 43 14.5 84.5t48.5 91.5l260 377h-340v102h530v-2l-361 -535q-25 -37 -34.5 -65.5t-9.5 -52.5q0 -43 21 -78t57 -56t80 -21t79.5 21t56.5 56t21 78q0 35 -15 65.5t-46 55.5h137q32 -61 32 -121q0 -54 -21 -101 t-57.5 -82t-84.5 -54.5t-103 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "el",
    unicode: "\u218B",
    horizAdvX: 750,
    d: "M147 0v2l193 358q-59 14 -107 52t-75.5 94t-27.5 121q0 60 22.5 112t63 91t93.5 60.5t113 21.5q73 0 137.5 -33t106.5 -95l-63 -121q-14 65 -66.5 106t-117.5 41q-50 0 -91.5 -24.5t-65.5 -65.5t-24 -92t24 -92t65.5 -65.5t91.5 -24.5q23 0 43.5 4t37.5 11l1 -1 l-187 -358h335v-102h-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowleft",
    unicode: "\u2190",
    horizAdvX: 1440,
    d: "M509 60l-413 300l414 300h165l-223 -162q-34 -25 -70.5 -49.5t-83.5 -49.5q36 4 77.5 5.5t95.5 2.5t127 1h662v-96h-664q-72 0 -125.5 1t-95 3t-77.5 5q47 -25 83.5 -49.5t70.5 -49.5l222 -162h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowup",
    unicode: "\u2191",
    horizAdvX: 1440,
    d: "M672 -180v664q0 72 1 125.5t3 95.5t5 77q-25 -47 -49.5 -83.5t-49.5 -70.5l-162 -222v165l300 413l300 -414v-165l-162 223q-25 34 -49.5 70.5t-49.5 83.5q4 -35 5.5 -77t2.5 -96t1 -127v-662h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowright",
    unicode: "\u2192",
    horizAdvX: 1440,
    d: "M765 60l223 162q34 25 70.5 49.5t83.5 49.5q-35 -3 -77 -5t-96 -3t-127 -1h-662v96h664q72 0 125.5 -1t95.5 -2.5t77 -5.5q-47 25 -83.5 49.5t-70.5 49.5l-222 162h165l413 -300l-414 -300h-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowdown",
    unicode: "\u2193",
    horizAdvX: 1440,
    d: "M720 -264l-300 414v165l162 -223q25 -34 49.5 -70.5t49.5 -83.5q-3 36 -5 77.5t-3 95.5t-1 127v662h96v-664q0 -72 -1 -125.5t-2.5 -95t-5.5 -77.5q25 47 49.5 83.5t49.5 70.5l162 222v-165z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowboth",
    unicode: "\u2194",
    horizAdvX: 1440,
    d: "M427 120l-331 240l330 240h153l-139 -102q-34 -25 -70.5 -49.5t-83.5 -49.5q36 4 77.5 5.5t95 2.5t125.5 1h272q72 0 125.5 -1t95.5 -2.5t77 -5.5q-47 25 -83 49.5t-71 49.5l-139 102h153l330 -240l-331 -240h-153l140 102q35 25 71 49.5t83 49.5q-35 -3 -77 -5t-96 -3 t-127 -1h-268q-73 0 -127 1t-95.5 3t-77.5 5q47 -25 83.5 -49.5t70.5 -49.5l140 -102h-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "arrowupdn",
    unicode: "\u2195",
    horizAdvX: 1440,
    d: "M720 -264l-240 331v153l102 -140q25 -34 49.5 -70.5t49.5 -83.5q-3 36 -5 77.5t-3 95.5t-1 127v268q0 73 1 127t3 96t5 77q-25 -47 -49.5 -83t-49.5 -71l-102 -140v153l240 331l240 -330v-153l-102 139q-25 35 -49.5 71t-49.5 83q4 -35 5.5 -77t2.5 -95.5t1 -125.5v-272 q0 -72 -1 -125.5t-2.5 -95t-5.5 -77.5q25 47 49.5 83.5t49.5 70.5l102 139v-153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2196",
    unicode: "\u2196",
    horizAdvX: 1440,
    d: "M1127 -69l-470 469q-51 52 -89 90.5t-65.5 69.5t-50.5 58q16 -51 24 -94.5t15 -84.5l43 -272l-117 117l-81 505l505 -80l116 -117l-271 42q-41 7 -84.5 15t-94.5 24q28 -22 58.5 -50t69 -65.5t89.5 -88.5l470 -471z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2197",
    unicode: "\u2197",
    horizAdvX: 1440,
    d: "M313 -69l-67 67l470 471q51 51 89.5 88.5t69.5 65.5t58 50q-51 -16 -94.5 -24t-84.5 -15l-271 -42l116 117l505 80l-81 -505l-117 -117l43 272q7 41 15 84.5t24 94.5q-22 -27 -50 -58t-65.5 -69.5t-89.5 -90.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2198",
    unicode: "\u2198",
    horizAdvX: 1440,
    d: "M1104 -69l-505 80l-116 117l271 -42q41 -7 84.5 -15t94.5 -24q-27 23 -58 50.5t-69.5 65t-89.5 88.5l-470 471l67 67l470 -469q52 -51 89.5 -90t65.5 -69.5t50 -58.5q-16 51 -24 94.5t-15 84.5l-43 272l117 -117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2199",
    unicode: "\u2199",
    horizAdvX: 1440,
    d: "M336 -69l81 505l117 117l-43 -272q-7 -41 -15 -84.5t-24 -94.5q23 28 50.5 58.5t65.5 69.5t89 90l470 469l67 -67l-470 -471q-51 -51 -89.5 -88.5t-69 -65t-58.5 -50.5q51 16 94.5 24t84.5 15l271 42l-116 -117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 740,
    d: "M371 -12q-66 0 -123.5 24t-101 67t-68 100t-24.5 122q0 63 23 118.5t64 97.5t94.5 65.5t114.5 23.5q44 0 83.5 -12.5t71.5 -41.5q-14 21 -44 60t-68.5 87t-79 97.5t-76 92.5t-59.5 71h123q29 -33 68 -80.5t80.5 -100t78.5 -101.5t61 -87q51 -79 74 -147.5t23 -133.5 q0 -70 -24 -128.5t-67.5 -102t-100.5 -67.5t-123 -24zM369 90q58 0 105.5 28.5t75.5 76.5t28 106t-28 105t-75.5 75.5t-105.5 28.5q-57 0 -104 -28.5t-75 -75.5t-28 -105t28 -106t75 -76.5t104 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emptyset",
    unicode: "\u2205",
    horizAdvX: 750,
    d: "M375 138q-52 0 -100 16t-88 44l-78 -78l-64 64l78 78q-30 39 -47 87t-17 101q0 65 24.5 121.5t68 99.5t100.5 67t123 24q53 0 100.5 -15.5t87.5 -44.5l78 78l64 -64l-78 -78q30 -39 47 -87t17 -101q0 -65 -24.5 -121.5t-68 -99.5t-100.5 -67t-123 -24zM375 234 q59 0 107.5 29t77.5 78.5t29 108.5q0 33 -9 63.5t-26 55.5l-298 -298q26 -18 56 -27.5t63 -9.5zM196 331l298 298q-25 17 -55.5 27t-63.5 10q-59 0 -108 -29t-77.5 -78t-28.5 -109q0 -33 9.5 -63t25.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2206",
    unicode: "\u2206",
    horizAdvX: 800,
    d: "M18 0l381 930h2l381 -930h-764zM171 95h452l-177 445q-13 34 -25 67t-24 79q-12 -46 -23 -79t-25 -67z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 800,
    d: "M126 -120v1020h548v-1020h-114v918h-320v-918h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 740,
    d: "M42 -120v2l350 531l-320 485v2h584v-102h-394l253 -385l-283 -431h448v-102h-638z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 750,
    d: "M90 404v92h570v-92h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 750,
    d: "M21 0l618 900h90l-618 -900h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    d: "M240 294q-44 0 -79.5 20.5t-56 56t-20.5 79.5t20.5 79.5t56 56t79.5 20.5q45 0 80.5 -20.5t55.5 -56t20 -79.5t-20 -79.5t-55.5 -56t-80.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 750,
    d: "M435 -149l-270 554h-105v90h171l140 -291q12 -25 24 -53.5t22 -57.5q8 29 16.5 59.5t16.5 57.5l228 750h96l-337 -1109h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 1140,
    d: "M306 138q-51 0 -93.5 23t-74 65.5t-49 99.5t-17.5 124q0 68 17.5 124.5t49 99t74 65.5t93.5 23q74 0 136.5 -51.5t127.5 -171.5q65 120 128 171.5t136 51.5q51 0 93.5 -23t74 -65.5t49 -99t17.5 -124.5q0 -67 -17.5 -124t-49 -99.5t-74 -65.5t-93.5 -23q-73 0 -136 51.5 t-128 171.5q-65 -120 -127.5 -171.5t-136.5 -51.5zM308 237q34 0 64.5 20t65 67t77.5 126q-43 80 -77.5 126.5t-65 66.5t-64.5 20q-29 0 -53.5 -15.5t-42.5 -44.5t-28 -67.5t-10 -85.5q0 -46 10 -85t28 -68t42.5 -44.5t53.5 -15.5zM832 237q29 0 53.5 15.5t42.5 44.5t28 68 t10 85q0 47 -10 85.5t-28 67.5t-42.5 44.5t-53.5 15.5q-33 0 -64 -20t-65 -66.5t-78 -126.5q44 -79 78 -126t65 -67t64 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 600,
    d: "M152 -192q-30 0 -61.5 7t-59.5 24l26 105q21 -23 46 -34.5t52 -11.5q24 0 46.5 10.5t36.5 36.5t14 71v750q0 67 26.5 113t71.5 69.5t98 23.5q30 0 61.5 -7t59.5 -24l-26 -105q-42 46 -98 46q-24 0 -46.5 -10.5t-36.5 -36t-14 -71.5v-750q0 -67 -26.5 -113t-71 -69.5 t-98.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 750,
    d: "M96 453l-48 83q27 59 76.5 91.5t107.5 32.5q40 0 76 -12.5t70 -29.5t67 -29.5t67 -12.5q50 0 85 31.5t57 79.5l48 -83q-27 -59 -76 -91.5t-108 -32.5q-40 0 -76 12.5t-70 29.5t-67 29.5t-67 12.5q-50 0 -84.5 -31.5t-57.5 -79.5zM96 213l-48 83q27 59 76.5 91.5 t107.5 32.5q40 0 76 -12.5t70 -29.5t67 -29.5t67 -12.5q50 0 85 31.5t57 79.5l48 -83q-27 -59 -76 -91.5t-108 -32.5q-40 0 -76 12.5t-70 29.5t-67 29.5t-67 12.5q-50 0 -84.5 -31.5t-57.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 750,
    d: "M183 150l69 141h-162v90h205l68 138h-273v90h316l69 141h92l-69 -141h162v-90h-205l-68 -138h273v-90h-316l-69 -141h-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 750,
    d: "M660 218l-600 291v2l600 293v-96l-300 -145q-28 -13 -59 -26l-62 -26q31 -12 62 -24.5t59 -26.5l300 -144v-98zM90 77v86h570v-86h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 750,
    d: "M90 218v96l300 145q28 14 59 26.5t62 25.5q-31 12 -62 25t-59 26l-300 144v98l600 -291v-2zM90 77v86h570v-86h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "filledbox",
    unicode: "\u25A0",
    horizAdvX: 1440,
    d: "M240 -120v960h960v-960h-960z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25A1",
    unicode: "\u25A1",
    horizAdvX: 1440,
    d: "M240 -120v960h960v-960h-960zM324 -36h792v792h-792v-792z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25AA",
    unicode: "\u25AA",
    horizAdvX: 600,
    d: "M90 150v420h420v-420h-420z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25AB",
    unicode: "\u25AB",
    horizAdvX: 600,
    d: "M90 150v420h420v-420h-420zM168 228h264v264h-264v-264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "triagup",
    unicode: "\u25B2",
    horizAdvX: 1440,
    d: "M124 -120l596 1032l596 -1032h-1192z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B3",
    unicode: "\u25B3",
    horizAdvX: 1440,
    d: "M124 -120l596 1032l596 -1032h-1192zM268 -36h904l-452 779z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B4",
    unicode: "\u25B4",
    horizAdvX: 600,
    d: "M15 150l285 492l285 -492h-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B5",
    unicode: "\u25B5",
    horizAdvX: 600,
    d: "M15 150l285 492l285 -492h-570zM140 222h320l-160 273z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B6",
    unicode: "\u25B6",
    horizAdvX: 1440,
    d: "M270 -207v1194l1032 -597z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B7",
    unicode: "\u25B7",
    horizAdvX: 1440,
    d: "M270 -206v1192l1032 -596zM354 -62l779 452l-779 452v-904z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B8",
    unicode: "\u25B8",
    horizAdvX: 600,
    d: "M102 75v570l492 -285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25B9",
    unicode: "\u25B9",
    horizAdvX: 600,
    d: "M102 75v570l492 -285zM174 200l273 160l-273 160v-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "triagdn",
    unicode: "\u25BC",
    horizAdvX: 1440,
    d: "M720 -192l-597 1032h1194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25BD",
    unicode: "\u25BD",
    horizAdvX: 1440,
    d: "M720 -192l-596 1032h1192zM720 -23l452 779h-904z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25BE",
    unicode: "\u25BE",
    horizAdvX: 600,
    d: "M300 78l-285 492h570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25BF",
    unicode: "\u25BF",
    horizAdvX: 600,
    d: "M300 78l-285 492h570zM300 225l160 273h-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C0",
    unicode: "\u25C0",
    horizAdvX: 1440,
    d: "M1170 -207l-1032 597l1032 597v-1194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C1",
    unicode: "\u25C1",
    horizAdvX: 1440,
    d: "M1170 -206l-1032 596l1032 596v-1192zM1086 -62v904l-779 -452z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C2",
    unicode: "\u25C2",
    horizAdvX: 600,
    d: "M498 75l-492 285l492 285v-570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C3",
    unicode: "\u25C3",
    horizAdvX: 600,
    d: "M498 75l-492 285l492 285v-570zM426 200v320l-273 -160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C6",
    unicode: "\u25C6",
    horizAdvX: 1440,
    d: "M720 -319l-679 679l679 679l679 -679z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25C7",
    unicode: "\u25C7",
    horizAdvX: 1440,
    d: "M720 -319l-679 679l679 679l679 -679zM720 -200l560 560l-560 560l-560 -560z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 600,
    d: "M300 -132l-285 492l285 492l285 -492zM300 24l197 336l-197 336l-197 -336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circle",
    unicode: "\u25CB",
    horizAdvX: 1440,
    d: "M720 -192q-114 0 -214 43t-176 119t-119 176t-43 214t43 214t119 176t176 119t214 43t214 -43t176 -119t119 -176t43 -214t-43 -214t-119 -176t-176 -119t-214 -43zM720 -102q96 0 179.5 36t147 99.5t99.5 147t36 179.5t-36 179.5t-99.5 147t-147 99.5t-179.5 36 t-179.5 -36t-147 -99.5t-99.5 -147t-36 -179.5t36 -179.5t99.5 -147t147 -99.5t179.5 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25CF",
    unicode: "\u25CF",
    horizAdvX: 1440,
    d: "M720 -192q-114 0 -214 43t-176 119t-119 176t-43 214t43 214t119 176t176 119t214 43t214 -43t176 -119t119 -176t43 -214t-43 -214t-119 -176t-176 -119t-214 -43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "openbullet",
    unicode: "\u25E6",
    horizAdvX: 600,
    d: "M300 132q-64 0 -116.5 31t-83.5 83t-31 114q0 63 31 114.5t83.5 82.5t116.5 31q65 0 117 -31t83 -82.5t31 -114.5q0 -62 -31 -114t-83 -83t-117 -31zM300 216q40 0 72 19.5t50.5 52.5t18.5 72q0 40 -18.5 72.5t-50.5 52t-72 19.5t-72 -19.5t-50.5 -52t-18.5 -72.5 q0 -39 18.5 -72t50.5 -52.5t72 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27E8",
    unicode: "\u27E8",
    d: "M312 -180l-264 570l264 570h114l-264 -570l264 -570h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni27E9",
    unicode: "\u27E9",
    d: "M54 -180l264 570l-264 570h114l264 -570l-264 -570h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniF8FF",
    unicode: "\uF8FF",
    horizAdvX: 1440,
    d: "M120 -240v1200h1200v-1200h-1200zM520 220l198 198l197 -198h-395zM270 120h900v6l-390 390v204h-120v-204l-390 -390v-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni004A0301",
    horizAdvX: 540,
    d: "M188 -12q-32 0 -64 6.5t-60.5 21t-51.5 38.5l33 120q23 -39 59.5 -61.5t82.5 -22.5q53 0 92 37t39 129v644h114v-653q0 -89 -34 -146.5t-89.5 -85t-120.5 -27.5zM321 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM296 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62 t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAF.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z M288 879l76 150h112l-104 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB7.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM333 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM342 675q-50 0 -91 23t-65 62.5t-24 88.5h88q0 -38 27.5 -65t64.5 -27t64.5 27t27.5 65h88q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB1.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23z M312 879l-104 150h112l76 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB3.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23z M300 879q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EB5.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5z M194 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM153 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA5.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM474 819l76 150h112l-104 -150h-84zM153 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5 t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAD.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM333 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM153 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA7.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM548 819l-104 150h112l76 -150h-84zM153 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5 t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA9.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM510 819q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28 t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM153 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EAB.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM153 690l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM194 892l-26 73 q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0201.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM411 690l-101 180h120l66 -180h-85zM189 690l-101 180h120l66 -180h-85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM222 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5 t-24.5 -25t-35.5 -9.5zM462 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA1.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM333 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM297 690l-125 180h126l90 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni1EA3.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM310 690q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-37.5 13.5q-21 0 -39 -11t-29 -25l-21 82q22 17 49 24.5t53 7.5 q53 0 91.5 -30.5t38.5 -83.5q0 -34 -14 -59.5t-31 -45.5h-98z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0203.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM162 675q0 50 24 89.5t65 62t91 22.5t91 -23t65 -62t24 -89h-88q0 38 -27.5 65t-64.5 27t-64.5 -27t-27.5 -65h-88z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM165 738v84h354v-84h-354z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek.ss02",
    horizAdvX: 690,
    d: "M611 -312q-65 0 -115 41.5t-50 117.5q0 40 16 78t44 75v100q-40 -55 -98 -81.5t-124 -26.5q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112 q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368q-28 -34 -44 -65t-16 -69q0 -46 24.5 -65.5t62.5 -19.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17z M342 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM342 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17z M342 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5zM306 957l56 123h105l-77 -123h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde.ss02",
    horizAdvX: 690,
    d: "M284 -8q-65 0 -117.5 24t-82.5 67t-30 101q0 61 34 104.5t92.5 66.5t133.5 23q55 0 103.5 -12.5t88.5 -35.5v18q0 67 -46.5 115.5t-136.5 48.5q-61 0 -110 -23t-83 -60l-28 112q43 29 100.5 48t125.5 19q81 0 143.5 -29t98.5 -82.5t36 -128.5v-368h-100v100 q-40 -55 -98 -81.5t-124 -26.5zM294 82q51 0 97.5 20t77.5 57t37 87q-40 19 -89 30.5t-96 11.5q-70 0 -114.5 -27t-44.5 -77q0 -42 34 -72t98 -30zM158 683l-32 91q20 40 51 60.5t71 20.5q34 0 64.5 -13.5t60 -27t57.5 -13.5q34 0 57.5 20t38.5 56l32 -91q-20 -40 -51 -60.5 t-71 -20.5q-33 0 -64 13.5t-60 27t-58 13.5q-34 0 -57.5 -20t-38.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i.loclTRK",
    horizAdvX: 300,
    d: "M96 0v600h108v-600h-108zM150 708q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni006A0301",
    horizAdvX: 300,
    d: "M31 -312l-22 93q37 0 62 21t25 76v722h108v-724q0 -90 -49.5 -139t-123.5 -49zM104 690l90 180h126l-125 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.ss03",
    horizAdvX: 330,
    d: "M269 -12q-74 0 -123.5 49t-49.5 139v784h108v-782q0 -55 24.5 -76t62.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute.ss03",
    horizAdvX: 330,
    d: "M269 -12q-74 0 -123.5 49t-49.5 139v784h108v-782q0 -55 24.5 -76t62.5 -21zM96 1050l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron.ss03",
    d: "M269 -12q-74 0 -123.5 49t-49.5 139v784h108v-782q0 -55 24.5 -76t62.5 -21zM260 660q45 56 72.5 130t27.5 170h96q0 -86 -23.5 -161t-64.5 -139h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni013C.ss03",
    horizAdvX: 330,
    d: "M269 -12q-74 0 -123.5 49t-49.5 139v784h108v-782q0 -55 24.5 -76t62.5 -21zM12 -330q34 42 57.5 94t28.5 116h104q-4 -58 -24 -110.5t-50 -99.5h-116z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot.ss03",
    horizAdvX: 420,
    d: "M269 -12q-74 0 -123.5 49t-49.5 139v784h108v-782q0 -55 24.5 -76t62.5 -21zM360 348q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash.ss03",
    horizAdvX: 390,
    d: "M299 -12q-74 0 -123.5 49t-49.5 139v228l-96 -63l-38 60l134 88v471h108v-400l90 59l38 -60l-128 -84v-297q0 -55 24.5 -76t62.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine.ss02",
    d: "M191 412q-62 0 -102.5 33t-40.5 85q0 55 46 87t119 32q31 0 58 -6t53 -18v8q0 35 -29 59t-79 24q-34 0 -65 -11t-54 -31l-19 77q31 17 68.5 27t77.5 10q55 0 96 -18t64.5 -52t23.5 -82v-216h-84v50q-25 -28 -59 -43t-74 -15zM206 484q29 0 55 10.5t43.5 28.5t19.5 40 q-21 8 -48.5 14t-53.5 6q-39 0 -63 -13t-24 -37q0 -21 19 -35t52 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_b",
    horizAdvX: 1610,
    d: "M1257 -8q-62 0 -116 23.5t-95 63.5v-79h-100v510h-282v-510h-108v510h-282v-510h-108v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5 t-34.5 -34t-13.5 -68.5v-170h285v360h108v-431q40 37 92 58t111 21q62 0 116 -24t95.5 -66.5t64.5 -98t23 -119.5t-23 -119.5t-64.5 -98t-95.5 -66.5t-116 -24zM271 600h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117zM1243 90 q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_h",
    horizAdvX: 1570,
    d: "M166 0v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-445q34 47 84 72t107 25q64 0 118.5 -31.5 t88.5 -91t34 -144.5v-345h-108v330q0 48 -19 89t-55 66t-88 25q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108v510h-282v-510h-108v510h-282v-510h-108zM271 600h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_j",
    horizAdvX: 1150,
    d: "M881 -312l-22 93q37 0 62 21t25 76v632h-282v-510h-108v510h-282v-510h-108v510h-136v90h139v103q0 86 38.5 146t101 91.5t135.5 31.5q55 0 103.5 -15.5t90.5 -49.5q37 32 83.5 48.5t98.5 16.5q50 0 94 -13.5t79 -39.5l-28 -113q-25 33 -62.5 54.5t-83.5 21.5 q-67 0 -112.5 -42t-45.5 -123v-117h393v-724q0 -60 -22.5 -102t-61.5 -64t-89 -22zM271 600h288v121q0 31 5.5 57t15.5 49q-26 25 -60.5 40t-75.5 15q-50 0 -89 -21t-61.5 -61t-22.5 -96v-104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_k",
    horizAdvX: 1480,
    d: "M166 0v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-960h-108v510h-282v-510h-108v510h-282 v-510h-108zM271 600h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117zM1337 0l-271 330l223 270h125l-219 -262l279 -338h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l.ss03",
    horizAdvX: 1180,
    d: "M1119 -12q-74 0 -123.5 49t-49.5 139v334h-282v-510h-108v510h-282v-510h-108v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94.5 -14t84.5 -44q27 29 65 43.5t81 14.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34 t-13.5 -68.5v-170h285v360h108v-782q0 -55 24.5 -76t62.5 -21zM271 600h288v177q0 13 1 25t3 23q-25 27 -59 42t-75 15q-45 0 -80.5 -19t-56.5 -55.5t-21 -90.5v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_b",
    horizAdvX: 1220,
    d: "M867 -8q-62 0 -116 23.5t-95 63.5v-79h-100v510h-282v-510h-108v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-431q40 37 92 58t111 21 q62 0 116 -24t95.5 -66.5t64.5 -98t23 -119.5t-23 -119.5t-64.5 -98t-95.5 -66.5t-116 -24zM853 90q57 0 103.5 28.5t74 76t27.5 105.5t-27.5 105.5t-74 76t-103.5 28.5t-103.5 -28.5t-74 -76t-27.5 -105.5t27.5 -105.5t74 -76t103.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_h",
    horizAdvX: 1180,
    d: "M166 0v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-445q34 47 84 72t107 25q64 0 118.5 -31.5t88.5 -91t34 -144.5v-345h-108v330 q0 48 -19 89t-55 66t-88 25q-42 0 -79 -20.5t-60 -59.5t-23 -97v-333h-108v510h-282v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_j",
    horizAdvX: 760,
    d: "M491 -312l-22 93q37 0 62 21t25 76v632h-282v-510h-108v510h-136v90h139v116q0 82 36.5 139t96 87t128.5 30q50 0 94 -13.5t79 -39.5l-28 -113q-25 32 -62.5 51t-83.5 19q-67 0 -112.5 -42t-45.5 -123v-111h393v-724q0 -60 -22.5 -102t-61.5 -64t-89 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_k",
    horizAdvX: 1090,
    d: "M166 0v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-960h-108v510h-282v-510h-108zM947 0l-271 330l223 270h125l-219 -262l279 -338h-137z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl.ss03",
    horizAdvX: 790,
    d: "M729 -12q-74 0 -123.5 49t-49.5 139v334h-282v-510h-108v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-21 23 -46 34.5t-52 11.5q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h285v360h108v-782q0 -55 24.5 -76t62.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_t",
    horizAdvX: 840,
    d: "M166 0v510h-136v90h139v172q0 66 26.5 110.5t71.5 67t98 22.5q30 0 61.5 -7t59.5 -24l-26 -105q-42 46 -98 46q-22 0 -43 -9.5t-34.5 -34t-13.5 -68.5v-170h288v200h102v-200h149v-90h-146v-510h-108v510h-282v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t_t",
    horizAdvX: 840,
    d: "M166 0v510h-136v90h139v200h102v-200h288v200h102v-200h149v-90h-146v-510h-108v510h-282v-510h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.zero",
    horizAdvX: 750,
    d: "M375 -12q-69 0 -126.5 34t-99.5 96.5t-65.5 147t-23.5 184.5q0 101 23.5 185t65.5 146.5t99.5 96.5t126.5 34t126.5 -34t99.5 -96.5t65.5 -146.5t23.5 -185q0 -100 -23.5 -184.5t-65.5 -147t-99.5 -96.5t-126.5 -34zM375 88q44 0 81.5 27t66 75.5t44 115t15.5 144.5 t-15.5 144.5t-44 115t-66 75.5t-81.5 27t-81.5 -27t-66 -75.5t-44 -115t-15.5 -144.5t15.5 -144.5t44 -115t66 -75.5t81.5 -27zM375 390q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf",
    horizAdvX: 750,
    d: "M375 -12q-79 0 -138 39.5t-98.5 106t-59 149t-19.5 167.5t19.5 167.5t59 149t98.5 106t138 39.5t138 -39.5t98.5 -106t59 -149t19.5 -167.5t-19.5 -167.5t-59 -149t-98.5 -106t-138 -39.5zM375 90q53 0 91 32t62 85t36 116.5t12 126.5t-12 126.5t-36 116.5t-62 85t-91 32 q-52 0 -90.5 -32t-62.5 -85t-36 -116.5t-12 -126.5t12 -126.5t36 -116.5t62.5 -85t90.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf.ss01",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf.zero",
    horizAdvX: 750,
    d: "M375 -12q-69 0 -126.5 34t-99.5 96.5t-65.5 147t-23.5 184.5q0 101 23.5 185t65.5 146.5t99.5 96.5t126.5 34t126.5 -34t99.5 -96.5t65.5 -146.5t23.5 -185q0 -100 -23.5 -184.5t-65.5 -147t-99.5 -96.5t-126.5 -34zM375 88q44 0 81.5 27t66 75.5t44 115t15.5 144.5 t-15.5 144.5t-44 115t-66 75.5t-81.5 27t-81.5 -27t-66 -75.5t-44 -115t-15.5 -144.5t15.5 -144.5t44 -115t66 -75.5t81.5 -27zM375 390q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lf.zero.ss01",
    horizAdvX: 1060,
    d: "M530 -18q-97 0 -182.5 36.5t-150 100.5t-101 149t-36.5 182t36.5 182t101 149t150 100.5t182.5 36.5q98 0 183 -36.5t149.5 -100.5t101 -149t36.5 -182t-36.5 -182t-101 -149t-149.5 -100.5t-183 -36.5zM530 90q74 0 138 28t112 77.5t75 114.5t27 140t-27 140t-75 114.5 t-112 77.5t-138 28t-138 -28t-112 -77.5t-75 -114.5t-27 -140t27 -140t75 -114.5t112 -77.5t138 -28zM530 390q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lf",
    d: "M222 0v755l-150 -75v108l262 132h2v-920h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lf",
    horizAdvX: 690,
    d: "M89 0v2l361 535q26 38 35 66t9 52q0 43 -21 78t-57 56t-80 21t-79.5 -21t-56.5 -56t-21 -78q0 -34 15 -65t46 -56h-137q-32 61 -32 121q0 54 21 101t57.5 82t84.5 54.5t103 19.5q54 0 102 -19.5t84.5 -54.5t57.5 -82t21 -101q0 -28 -6 -56t-20 -57t-37 -63l-260 -377h340 v-102h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lf",
    horizAdvX: 690,
    d: "M312 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 103.5 27.5t73.5 73.5t27 103q0 56 -27.5 102.5t-73.5 74t-103 27.5q-28 0 -52 -6.5t-43 -17.5l-1 1l170 329h-278v96h444v-2l-169 -313q50 -10 94 -35.5t77 -64t51.5 -87 t18.5 -104.5q0 -64 -24.5 -120t-67 -97.5t-99 -65t-121.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lf",
    horizAdvX: 750,
    d: "M456 0v242h-432v2l337 656h120l-292 -562h270v202l102 54v-256h135v-96h-132v-242h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lf",
    horizAdvX: 690,
    d: "M312 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q56 0 102.5 27.5t74 73.5t27.5 102t-28 102t-74.5 73.5t-104.5 27.5q-50 0 -93.5 -22.5t-69.5 -60.5h-2v487h406v-102h-308v-222q20 9 41.5 12.5t41.5 3.5q61 0 115 -22.5t95.5 -63 t65 -95t23.5 -118.5t-24.5 -119.5t-68 -97.5t-100 -65t-119.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lf",
    horizAdvX: 750,
    d: "M375 -12q-66 0 -123 23t-100.5 65t-67.5 97.5t-24 119.5q0 39 10 76.5t27 70.5l241 460h124l-186 -343q28 22 57 29.5t59 7.5q62 0 115.5 -22.5t95 -63t64.5 -95t23 -119.5t-24 -120.5t-67.5 -97.5t-100.5 -65t-123 -23zM376 90q58 0 104.5 27.5t74 74t27.5 103.5 q0 56 -27.5 102.5t-74 74.5t-104.5 28q-57 0 -104 -28t-74.5 -74.5t-27.5 -102.5q0 -57 27.5 -103.5t74.5 -74t104 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lf",
    horizAdvX: 690,
    d: "M83 0l398 798h-430v102h599v-2l-445 -898h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lf",
    horizAdvX: 750,
    d: "M375 -12q-64 0 -120.5 23t-99.5 65t-67.5 97.5t-24.5 119.5q0 59 21 110.5t58 91.5t85 65q-29 28 -46 64t-17 81q0 44 16.5 81.5t45.5 66t67.5 44t81.5 15.5q44 0 82 -15.5t67 -44t45.5 -66t16.5 -81.5q0 -45 -17 -81.5t-46 -63.5q49 -25 85.5 -65t57.5 -91.5t21 -110.5 q0 -64 -24.5 -119.5t-67.5 -97.5t-99.5 -65t-120.5 -23zM375 90q57 0 103.5 27.5t73.5 73.5t27 103t-27 103.5t-73.5 73.5t-103.5 27t-103 -27t-73.5 -73.5t-27.5 -103.5t27.5 -103t73.5 -73.5t103 -27.5zM375 586q32 0 58 15.5t41.5 41.5t15.5 58t-15.5 58t-41.5 41.5 t-58 15.5t-58 -15.5t-41.5 -41.5t-15.5 -58t15.5 -58t41.5 -41.5t58 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lf",
    horizAdvX: 750,
    d: "M274 0l192 353q-26 -19 -54.5 -26t-56.5 -7q-58 0 -110.5 22t-92.5 61.5t-63 93t-23 116.5t24 117.5t66 95.5t97.5 63.5t118.5 22.5t118.5 -22.5t97.5 -63.5t66 -95.5t24 -117.5q0 -39 -9.5 -75t-26.5 -69l-242 -469h-126zM372 414q55 0 100 26.5t71.5 71.5t26.5 100 t-26.5 100t-71.5 71.5t-100 26.5t-100 -26.5t-71.5 -71.5t-26.5 -100t26.5 -100t71.5 -71.5t100 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dek.lf",
    horizAdvX: 690,
    d: "M353 -12q-54 0 -102 19.5t-84.5 54.5t-57.5 82t-21 101q0 43 14.5 84.5t48.5 91.5l260 377h-340v102h530v-2l-361 -535q-25 -37 -34.5 -65.5t-9.5 -52.5q0 -43 21 -78t57 -56t80 -21t79.5 21t56.5 56t21 78q0 35 -15 65.5t-46 55.5h137q32 -61 32 -121q0 -54 -21 -101 t-57.5 -82t-84.5 -54.5t-103 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "el.lf",
    horizAdvX: 690,
    d: "M117 0v2l193 358q-60 14 -107.5 52t-75 94t-27.5 121q0 60 22.5 112t63 91t93.5 60.5t113 21.5q73 0 137.5 -33t106.5 -95l-63 -121q-14 65 -66.5 106t-117.5 41q-50 0 -91.5 -24.5t-65.5 -65.5t-24 -92t24 -92t65.5 -65.5t91.5 -24.5q23 0 43.5 4t37.5 11l1 -1 l-187 -358h335v-102h-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.tf",
    horizAdvX: 750,
    d: "M375 -12q-79 0 -138 39.5t-98.5 106t-59 149t-19.5 167.5t19.5 167.5t59 149t98.5 106t138 39.5t138 -39.5t98.5 -106t59 -149t19.5 -167.5t-19.5 -167.5t-59 -149t-98.5 -106t-138 -39.5zM375 90q53 0 91 32t62 85t36 116.5t12 126.5t-12 126.5t-36 116.5t-62 85t-91 32 q-52 0 -90.5 -32t-62.5 -85t-36 -116.5t-12 -126.5t12 -126.5t36 -116.5t62.5 -85t90.5 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.tf.zero",
    horizAdvX: 750,
    d: "M375 -12q-69 0 -126.5 34t-99.5 96.5t-65.5 147t-23.5 184.5q0 101 23.5 185t65.5 146.5t99.5 96.5t126.5 34t126.5 -34t99.5 -96.5t65.5 -146.5t23.5 -185q0 -100 -23.5 -184.5t-65.5 -147t-99.5 -96.5t-126.5 -34zM375 88q44 0 81.5 27t66 75.5t44 115t15.5 144.5 t-15.5 144.5t-44 115t-66 75.5t-81.5 27t-81.5 -27t-66 -75.5t-44 -115t-15.5 -144.5t15.5 -144.5t44 -115t66 -75.5t81.5 -27zM375 390q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.tf",
    horizAdvX: 750,
    d: "M162 0v90h208v668l-208 -106v108l316 160h2v-830h168v-90h-486z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.tf",
    horizAdvX: 750,
    d: "M119 0v2l361 535q26 38 35 66t9 52q0 43 -21 78t-57 56t-80 21t-79.5 -21t-56.5 -56t-21 -78q0 -34 15 -65t46 -56h-137q-32 61 -32 121q0 54 21 101t57.5 82t84.5 54.5t103 19.5q54 0 102 -19.5t84.5 -54.5t57.5 -82t21 -101q0 -28 -6 -56t-20 -57t-37 -63l-260 -377 h340v-102h-530z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.tf",
    horizAdvX: 750,
    d: "M342 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q57 0 103.5 27.5t73.5 73.5t27 103q0 56 -27.5 102.5t-73.5 74t-103 27.5q-28 0 -52 -6.5t-43 -17.5l-1 1l170 329h-278v96h444v-2l-169 -313q50 -10 94 -35.5t77 -64t51.5 -87 t18.5 -104.5q0 -64 -24.5 -120t-67 -97.5t-99 -65t-121.5 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.tf",
    horizAdvX: 750,
    d: "M456 0v242h-432v2l337 656h120l-292 -562h270v202l102 54v-256h135v-96h-132v-242h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.tf",
    horizAdvX: 750,
    d: "M342 -12q-86 0 -157.5 40t-112.5 110l66 131q7 -51 36 -91.5t72.5 -64t95.5 -23.5q56 0 102.5 27.5t74 73.5t27.5 102t-28 102t-74.5 73.5t-104.5 27.5q-50 0 -93.5 -22.5t-69.5 -60.5h-2v487h406v-102h-308v-222q20 9 41.5 12.5t41.5 3.5q61 0 115 -22.5t95.5 -63 t65 -95t23.5 -118.5t-24.5 -119.5t-68 -97.5t-100 -65t-119.5 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.tf",
    horizAdvX: 750,
    d: "M381 -12q-66 0 -123 23t-100.5 65t-67.5 97.5t-24 119.5q0 39 10 76.5t27 70.5l241 460h124l-186 -343q28 22 57 29.5t59 7.5q62 0 115.5 -22.5t95 -63t64.5 -95t23 -119.5t-24 -120.5t-67.5 -97.5t-100.5 -65t-123 -23zM382 90q58 0 104.5 27.5t74 74t27.5 103.5 q0 56 -27.5 102.5t-74 74.5t-104.5 28q-57 0 -104 -28t-74.5 -74.5t-27.5 -102.5q0 -57 27.5 -103.5t74.5 -74t104 -27.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.tf",
    horizAdvX: 750,
    d: "M128 0l398 798h-430v102h599v-2l-445 -898h-122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.tf",
    horizAdvX: 750,
    d: "M375 -12q-64 0 -120.5 23t-99.5 65t-67.5 97.5t-24.5 119.5q0 59 21 110.5t58 91.5t85 65q-29 28 -46 64t-17 81q0 44 16.5 81.5t45.5 66t67.5 44t81.5 15.5q44 0 82 -15.5t67 -44t45.5 -66t16.5 -81.5q0 -45 -17 -81.5t-46 -63.5q49 -25 85.5 -65t57.5 -91.5t21 -110.5 q0 -64 -24.5 -119.5t-67.5 -97.5t-99.5 -65t-120.5 -23zM375 90q57 0 103.5 27.5t73.5 73.5t27 103t-27 103.5t-73.5 73.5t-103.5 27t-103 -27t-73.5 -73.5t-27.5 -103.5t27.5 -103t73.5 -73.5t103 -27.5zM375 586q32 0 58 15.5t41.5 41.5t15.5 58t-15.5 58t-41.5 41.5 t-58 15.5t-58 -15.5t-41.5 -41.5t-15.5 -58t15.5 -58t41.5 -41.5t58 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.tf",
    horizAdvX: 750,
    d: "M276 0l193 355q-27 -20 -56 -27.5t-58 -7.5q-58 0 -110.5 22t-92.5 61.5t-63 93t-23 116.5t24 117.5t66 95.5t97.5 63.5t118.5 22.5t118.5 -22.5t97.5 -63.5t66 -95.5t24 -117.5q0 -39 -9.5 -75t-26.5 -69l-242 -469h-124zM372 414q55 0 100 26.5t71.5 71.5t26.5 100 t-26.5 100t-71.5 71.5t-100 26.5t-100 -26.5t-71.5 -71.5t-26.5 -100t26.5 -100t71.5 -71.5t100 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dek.tf",
    horizAdvX: 750,
    d: "M383 -12q-54 0 -102 19.5t-84.5 54.5t-57.5 82t-21 101q0 43 14.5 84.5t48.5 91.5l260 377h-340v102h530v-2l-361 -535q-25 -37 -34.5 -65.5t-9.5 -52.5q0 -43 21 -78t57 -56t80 -21t79.5 21t56.5 56t21 78q0 35 -15 65.5t-46 55.5h137q32 -61 32 -121q0 -54 -21 -101 t-57.5 -82t-84.5 -54.5t-103 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "el.tf",
    horizAdvX: 750,
    d: "M147 0v2l193 358q-59 14 -107 52t-75.5 94t-27.5 121q0 60 22.5 112t63 91t93.5 60.5t113 21.5q73 0 137.5 -33t106.5 -95l-63 -121q-14 65 -66.5 106t-117.5 41q-50 0 -91.5 -24.5t-65.5 -65.5t-24 -92t24 -92t65.5 -65.5t91.5 -24.5q23 0 43.5 4t37.5 11l1 -1 l-187 -358h335v-102h-502z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.dnom",
    d: "M240 -12q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 68q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.dnom",
    d: "M228 0v371l-114 -57v84l202 102h2v-500h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.dnom",
    d: "M70 0v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.dnom",
    d: "M219 -12q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.dnom",
    d: "M272 0v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.dnom",
    d: "M220 -12q-49 0 -90.5 22t-67.5 59l48 91q6 -41 36.5 -66.5t71.5 -25.5q29 0 51 12t34.5 33.5t12.5 47.5q0 27 -12.5 48t-34.5 33.5t-51 12.5q-31 0 -52.5 -12.5t-38.5 -35.5h-2v273h238v-80h-168v-77q8 2 17.5 3t19.5 1q53 0 91 -23.5t58.5 -61t20.5 -81.5 q0 -47 -24 -86.5t-65 -63t-93 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.dnom",
    d: "M240 -12q-50 0 -91.5 23t-66 62.5t-24.5 88.5q0 22 5.5 43.5t15.5 40.5l125 234h90l-85 -157q11 5 22.5 6.5t21.5 1.5q46 0 84.5 -22t61.5 -59.5t23 -86.5t-24.5 -89t-66 -63t-91.5 -23zM240 68q27 0 48.5 13t34.5 34.5t13 47.5q0 27 -13 49t-34.5 35t-48.5 13t-48.5 -13 t-34.5 -35t-13 -49q0 -26 13 -47.5t34.5 -34.5t48.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.dnom",
    d: "M102 0l200 400h-216v80h349v-2l-237 -478h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.dnom",
    d: "M240 -12q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM240 68q26 0 46.5 11.5 t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM240 312q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.dnom",
    d: "M184 0l89 164q-11 -5 -23 -7t-23 -2q-44 0 -81.5 21.5t-59.5 59t-22 84.5q0 49 24 87.5t64 61.5t88 23q49 0 88.5 -22.5t63.5 -61.5t24 -87q0 -21 -5.5 -42.5t-14.5 -39.5l-120 -239h-92zM240 232q26 0 46 12.5t32 33t12 45.5t-12 45t-32 32t-46 12q-25 0 -45.5 -12 t-32.5 -32t-12 -45t12 -45.5t32.5 -33t45.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dek.dnom",
    d: "M253 -12q-45 0 -81 20.5t-57 55.5t-21 77q0 29 13 58.5t42 66.5q26 34 54 68.5t57 68.5q-22 -1 -41 -2t-39 -1h-114v80h344v-2l-198 -260q-20 -27 -26 -44.5t-6 -34.5q0 -29 20 -50t54 -21q32 0 53 20.5t21 54.5q0 31 -19 55h92q7 -13 10 -27.5t3 -28.5q0 -44 -21.5 -79 t-57.5 -55t-82 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "el.dnom",
    d: "M78 0v2l112 188q-27 11 -48.5 32t-33.5 49t-12 60q0 45 22.5 81.5t60.5 58t86 21.5q45 0 82 -19.5t61 -52.5l-48 -85q-8 33 -33 55t-60 22t-58.5 -22.5t-23.5 -57.5q0 -34 23 -57.5t61 -23.5q14 0 25.5 3t20.5 8l2 -2l-107 -180h204v-80h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numr",
    d: "M240 408q-48 0 -84 21.5t-60 58t-36 81.5t-12 91q0 47 12 91.5t36 81t60 58t84 21.5t84 -21.5t60 -58t36 -81t12 -91.5q0 -46 -12 -91t-36 -81.5t-60 -58t-84 -21.5zM240 488q37 0 59 26t32.5 66t10.5 80q0 41 -10.5 80.5t-32.5 65.5t-59 26q-36 0 -58.5 -26t-33 -65.5 t-10.5 -80.5q0 -40 10.5 -80t33 -66t58.5 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numr",
    d: "M228 420v371l-114 -57v84l202 102h2v-500h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numr",
    d: "M70 420v2l198 260q20 27 26 45t6 34q0 29 -20 50t-54 21q-32 0 -53 -20t-21 -55q0 -31 19 -55h-92q-7 14 -10 28t-3 28q0 44 21.5 79t58 55t81.5 20t81 -20.5t57 -55t21 -77.5q0 -29 -13 -58t-42 -67q-26 -34 -54 -68.5t-57 -68.5q23 2 41.5 2.5t38.5 0.5h102v-80h-332z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numr",
    d: "M219 408q-32 0 -61.5 10t-54 28t-41.5 43l48 91q6 -41 36 -66.5t74 -25.5q28 0 49.5 12.5t34 34t12.5 49.5t-13 49.5t-34.5 34t-48.5 12.5q-20 0 -36 -5t-29 -14l-2 2l84 157h-152v80h281v-2l-87 -153q35 -8 63 -31t44 -56t16 -73q0 -49 -24 -89.5t-65 -64t-94 -23.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numr",
    d: "M272 420v114h-248v2l187 364h92l-153 -295h124v99l80 44v-143h72v-71h-70v-114h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numr",
    d: "M220 408q-49 0 -90.5 22t-67.5 59l48 91q6 -41 36.5 -66.5t71.5 -25.5q29 0 51 12t34.5 33.5t12.5 47.5q0 27 -12.5 48t-34.5 33.5t-51 12.5q-31 0 -52.5 -12.5t-38.5 -35.5h-2v273h238v-80h-168v-77q8 2 17.5 3t19.5 1q53 0 91 -23.5t58.5 -61t20.5 -81.5 q0 -47 -24 -86.5t-65 -63t-93 -23.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numr",
    d: "M240 408q-50 0 -91.5 23t-66 62.5t-24.5 88.5q0 22 5.5 43.5t15.5 40.5l125 234h90l-85 -157q11 5 22.5 6.5t21.5 1.5q46 0 84.5 -22t61.5 -59.5t23 -86.5t-24.5 -89t-66 -63t-91.5 -23zM240 488q27 0 48.5 13t34.5 34.5t13 47.5q0 27 -13 49t-34.5 35t-48.5 13 t-48.5 -13t-34.5 -35t-13 -49q0 -26 13 -47.5t34.5 -34.5t48.5 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numr",
    d: "M102 420l200 400h-216v80h349v-2l-237 -478h-96z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numr",
    d: "M240 408q-47 0 -87 22.5t-64 61t-24 85.5q0 44 20.5 80t53.5 58q-13 15 -20.5 34t-7.5 41q0 35 17.5 62.5t47 43.5t64.5 16t64.5 -16t47 -43.5t17.5 -62.5q0 -22 -8 -41t-21 -34q34 -22 54.5 -58t20.5 -80q0 -48 -24 -86t-63.5 -60.5t-87.5 -22.5zM240 488 q26 0 46.5 11.5t32 32t11.5 46.5t-11.5 46.5t-32 32t-46.5 11.5t-46.5 -11.5t-32 -32t-11.5 -46.5t11.5 -46.5t32 -32t46.5 -11.5zM240 732q23 0 38.5 16t15.5 38q0 23 -15.5 38.5t-38.5 15.5q-22 0 -38 -15.5t-16 -38.5q0 -22 16 -38t38 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numr",
    d: "M184 420l89 164q-11 -5 -23 -7t-23 -2q-44 0 -81.5 21.5t-59.5 59t-22 84.5q0 49 24 87.5t64 61.5t88 23q49 0 88.5 -22.5t63.5 -61.5t24 -87q0 -21 -5.5 -42.5t-14.5 -39.5l-120 -239h-92zM240 652q26 0 46 12.5t32 33t12 45.5t-12 45t-32 32t-46 12q-25 0 -45.5 -12 t-32.5 -32t-12 -45t12 -45.5t32.5 -33t45.5 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dek.numr",
    d: "M253 408q-45 0 -81 20.5t-57 55.5t-21 77q0 29 13 58.5t42 66.5q26 34 54 68.5t57 68.5q-22 -1 -41 -2t-39 -1h-102v80h332v-2l-198 -260q-20 -27 -26 -44.5t-6 -34.5q0 -29 20 -50t54 -21q32 0 53 20.5t21 54.5q0 31 -19 55h92q7 -13 10 -27.5t3 -28.5q0 -44 -21.5 -79 t-57.5 -55t-82 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "el.numr",
    d: "M78 420v2l112 188q-27 11 -48.5 32t-33.5 49t-12 60q0 45 22.5 81.5t60.5 58t86 21.5q45 0 82 -19.5t61 -52.5l-48 -85q-8 33 -33 55t-60 22t-58.5 -22.5t-23.5 -57.5q0 -34 23 -57.5t61 -23.5q14 0 25.5 3t20.5 8l2 -2l-107 -180h204v-80h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dekinferior",
    d: "M253 -252q-45 0 -81 20.5t-57 55.5t-21 77q0 29 13 58.5t42 66.5q26 34 54 68.5t57 68.5q-22 -1 -41 -2t-39 -1h-114v80h344v-2l-198 -260q-20 -27 -26 -44.5t-6 -34.5q0 -29 20 -50t54 -21q32 0 53 20.5t21 54.5q0 31 -19 55h92q7 -13 10 -27.5t3 -28.5q0 -44 -21.5 -79 t-57.5 -55t-82 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "elinferior",
    d: "M78 -240v2l112 188q-27 11 -48.5 32t-33.5 49t-12 60q0 45 22.5 81.5t60.5 58t86 21.5q45 0 82 -19.5t61 -52.5l-48 -85q-8 33 -33 55t-60 22t-58.5 -22.5t-23.5 -57.5q0 -34 23 -57.5t61 -23.5q14 0 25.5 3t20.5 8l2 -2l-107 -180h204v-80h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "deksuperior",
    d: "M253 648q-45 0 -81 20.5t-57 55.5t-21 77q0 29 13 58.5t42 66.5q26 34 54 68.5t57 68.5q-22 -1 -41 -2t-39 -1h-102v80h332v-2l-198 -260q-20 -27 -26 -44.5t-6 -34.5q0 -29 20 -50t54 -21q32 0 53 20.5t21 54.5q0 31 -19 55h92q7 -13 10 -27.5t3 -28.5q0 -44 -21.5 -79 t-57.5 -55t-82 -20z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "elsuperior",
    d: "M78 660v2l112 188q-27 11 -48.5 32t-33.5 49t-12 60q0 45 22.5 81.5t60.5 58t86 21.5q45 0 82 -19.5t61 -52.5l-48 -85q-8 33 -33 55t-60 22t-58.5 -22.5t-23.5 -57.5q0 -34 23 -57.5t61 -23.5q14 0 25.5 3t20.5 8l2 -2l-107 -180h204v-80h-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon.case",
    d: "M240 546q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5zM240 198q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5 t-27.5 -28t-40.5 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon.case",
    d: "M240 546q-22 0 -39.5 10.5t-28 28t-10.5 39.5t10.5 39.5t28 28t39.5 10.5q23 0 40.5 -10.5t27.5 -28t10 -39.5t-10 -39.5t-27.5 -28t-40.5 -10.5zM86 60q30 37 52.5 82.5t35 99.5t12.5 118h108q0 -85 -23.5 -160.5t-64.5 -139.5h-120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT",
    horizAdvX: 360,
    d: "M180 378q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.loclCAT.case",
    horizAdvX: 360,
    d: "M180 378q-30 0 -51 21t-21 51q0 31 21 51.5t51 20.5q31 0 51.5 -20.5t20.5 -51.5q0 -30 -20.5 -51t-51.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarteremdash",
    horizAdvX: 1080,
    d: "M60 249v102h960v-102h-960z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen.case",
    horizAdvX: 360,
    d: "M30 402v96h300v-96h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash.case",
    horizAdvX: 720,
    d: "M60 402v96h600v-96h-600z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarteremdash.case",
    horizAdvX: 1080,
    d: "M60 399v102h960v-102h-960z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash.case",
    horizAdvX: 1440,
    d: "M60 399v102h1320v-102h-1320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010.case",
    horizAdvX: 360,
    d: "M30 402v96h300v-96h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.dnom",
    horizAdvX: 320,
    d: "M211 -120q-49 80 -76 171.5t-27 189.5q0 97 27 188t76 171h95q-35 -50 -60 -107t-38.5 -120t-13.5 -132t13.5 -133t38.5 -121t60 -107h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.dnom",
    horizAdvX: 320,
    d: "M14 -120q36 51 61 108.5t38 121t13 130.5q0 68 -13 131t-38 120.5t-61 108.5h94q50 -80 77 -171t27 -189q0 -97 -27 -188.5t-77 -171.5h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.numr",
    horizAdvX: 320,
    d: "M211 300q-49 80 -76 171.5t-27 189.5q0 97 27 188t76 171h95q-35 -50 -60 -107t-38.5 -120t-13.5 -132t13.5 -133t38.5 -121t60 -107h-95z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.numr",
    horizAdvX: 320,
    d: "M14 300q36 51 61 108.5t38 121t13 130.5q0 68 -13 131t-38 120.5t-61 108.5h94q50 -80 77 -171t27 -189q0 -97 -27 -188.5t-77 -171.5h-94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft.case",
    horizAdvX: 630,
    d: "M198 270l-192 180l192 180h132l-192 -180l192 -180h-132zM468 270l-192 180l192 180h132l-192 -180l192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright.case",
    horizAdvX: 630,
    d: "M30 270l192 180l-192 180h132l192 -180l-192 -180h-132zM300 270l192 180l-192 180h132l192 -180l-192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft.case",
    horizAdvX: 360,
    d: "M198 270l-192 180l192 180h132l-192 -180l192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright.case",
    horizAdvX: 360,
    d: "M30 270l192 180l-192 180h132l192 -180l-192 -180h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.ss02",
    horizAdvX: 1260,
    d: "M651 -192q-120 0 -224 42.5t-182.5 117.5t-122.5 174.5t-44 214.5q0 116 44.5 216.5t123 176.5t182.5 119t224 43q114 0 212.5 -39t172.5 -109t115.5 -163.5t41.5 -202.5q0 -68 -18 -126t-50.5 -100.5t-76.5 -66t-96 -23.5t-93 26.5t-58 71.5q-37 -47 -92 -72.5 t-120 -25.5q-61 0 -108.5 22t-74.5 61.5t-27 89.5q0 53 29.5 92t83 61t124.5 22q50 0 94 -10.5t82 -32.5v16q0 66 -45 105.5t-120 39.5q-51 0 -96 -18.5t-79 -53.5l-25 102q45 29 97 44.5t107 15.5q76 0 132 -27t87.5 -76t31.5 -114v-173q0 -39 23 -63.5t60 -24.5 q29 0 53.5 16.5t42 46.5t27 71.5t9.5 91.5q0 95 -33 174.5t-93 138t-141 91t-178 32.5q-101 0 -188 -35.5t-152.5 -99t-102 -148t-36.5 -182.5q0 -97 36.5 -180.5t101 -146t151 -97.5t186.5 -35q89 0 167 29t142 87l26 -100q-72 -52 -156.5 -79t-176.5 -27zM601 166 q50 0 91.5 19t68.5 51.5t32 72.5q-38 17 -82 27t-85 10q-67 0 -105.5 -24.5t-38.5 -66.5q0 -40 33 -64.5t86 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus.dnom",
    d: "M201 35v169h-166v72h166v169h77v-169h167v-72h-167v-169h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus.dnom",
    d: "M54 202v76h372v-76h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal.dnom",
    d: "M54 280v73h372v-73h-372zM54 127v73h372v-73h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus.numr",
    d: "M201 455v169h-166v72h166v169h77v-169h167v-72h-167v-169h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus.numr",
    d: "M54 622v76h372v-76h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal.numr",
    d: "M54 700v73h372v-73h-372zM54 547v73h372v-73h-372z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb.case",
    horizAdvX: 0,
    d: "M216 990l144 180h144l-180 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060301",
    horizAdvX: 0,
    d: "M360 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5zM306 879l76 150h112l-104 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060300",
    horizAdvX: 0,
    d: "M360 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM330 879l-104 150h112l76 -150h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060309",
    horizAdvX: 0,
    d: "M360 675q-50 0 -91 22.5t-65 62t-24 89.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -49 -24 -88.5t-65 -62.5t-91 -23zM318 879q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46 t-29.5 -38h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03060303",
    horizAdvX: 0,
    d: "M360 675q-50 0 -91 23t-65 62.5t-24 88.5h84q0 -40 29 -68t67 -28t67 28t29 68h84q0 -50 -24 -89.5t-64.5 -62t-91.5 -22.5zM212 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11 t-48.5 21.5t-46.5 10.5q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt",
    horizAdvX: 0,
    d: "M265 660q45 56 72.5 130t27.5 170h96q0 -86 -23.5 -161t-64.5 -139h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030C.alt.t",
    horizAdvX: 0,
    d: "M265 720q38 47 64 106.5t33 133.5h96q-7 -67 -29 -127t-56 -113h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020301",
    horizAdvX: 0,
    d: "M492 819l76 150h112l-104 -150h-84zM171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020300",
    horizAdvX: 0,
    d: "M566 819l-104 150h112l76 -150h-84zM171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020309",
    horizAdvX: 0,
    d: "M528 819q22 22 35 40t13 33q0 19 -13 31.5t-35 12.5q-19 0 -35.5 -10t-27.5 -23l-19 75q20 16 45 23t49 7q49 0 84.5 -28t35.5 -77q0 -25 -12.5 -46t-29.5 -38h-90zM171 690l188 219h2l188 -219h-114q-21 21 -38 43.5t-39 53.5q-22 -31 -39 -53.5t-38 -43.5h-110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03020303",
    horizAdvX: 0,
    d: "M171 690l188 207h2l188 -207h-114q-21 20 -38 40.5t-39 48.5q-22 -28 -39 -48.5t-38 -40.5h-110zM212 892l-26 73q17 32 42 49t56 17q27 0 52 -11t48.5 -22t46.5 -11q27 0 46 16.5t31 44.5l26 -73q-16 -32 -41 -48.5t-57 -16.5q-27 0 -52 11t-48.5 21.5t-46.5 10.5 q-52 0 -77 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03080304",
    horizAdvX: 0,
    d: "M189 921v78h342v-78h-342zM240 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM480 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9 t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.A.case",
    horizAdvX: 0,
    d: "M576 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM264 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.case",
    horizAdvX: 0,
    d: "M480 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5zM240 1011q-28 0 -48.5 20.5t-20.5 48.5q0 29 20.5 49t48.5 20q29 0 49 -20t20 -49q0 -28 -20 -48.5t-49 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.O.case",
    horizAdvX: 0,
    d: "M780 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5zM240 918q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37 q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.W.case",
    horizAdvX: 0,
    d: "M576 918q-31 0 -51.5 20.5t-20.5 51.5t20.5 51.5t51.5 20.5t51.5 -20.5t20.5 -51.5t-20.5 -51.5t-51.5 -20.5zM264 918q-31 0 -51.5 20.5t-20.5 51.5t20.5 51.5t51.5 20.5t51.5 -20.5t20.5 -51.5t-20.5 -51.5t-51.5 -20.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03070304",
    horizAdvX: 0,
    d: "M360 711q-19 0 -34.5 9.5t-25 25t-9.5 34.5q0 20 9.5 35.5t25 24.5t34.5 9q20 0 35.5 -9t24.5 -24.5t9 -35.5q0 -19 -9 -34.5t-24.5 -25t-35.5 -9.5zM189 921v78h342v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0307.case",
    horizAdvX: 0,
    d: "M360 1008q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelowcomb.case",
    horizAdvX: 0,
    d: "M360 -252q-20 0 -36.5 9.5t-26 26t-9.5 36.5q0 21 9.5 37t26 25.5t36.5 9.5q21 0 37 -9.5t25.5 -25.5t9.5 -37q0 -20 -9.5 -36.5t-25.5 -26t-37 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb.case",
    horizAdvX: 0,
    d: "M396 990l-180 180h144l144 -180h-108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hookabovecomb.case",
    horizAdvX: 0,
    d: "M324 990q25 29 38.5 51.5t13.5 41.5q0 21 -14.5 34.5t-40.5 13.5q-23 0 -41 -11t-29 -25l-22 85q22 17 51.5 24.5t57.5 7.5q38 0 68 -13.5t47.5 -39t17.5 -61.5q0 -34 -14 -61t-31 -47h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0304.narrow",
    horizAdvX: 0,
    d: "M213 740v80h294v-80h-294z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A0301",
    horizAdvX: 0,
    d: "M360 651q-36 0 -66 17t-48 46.5t-18 65.5q0 37 18 66t48 46t66 17t66 -17t48 -46t18 -66t-17.5 -66t-47.5 -46t-67 -17zM360 717q26 0 44.5 18.5t18.5 44.5t-18.5 44.5t-44.5 18.5t-44.5 -18.5t-18.5 -44.5t18.5 -44.5t44.5 -18.5zM324 957l56 123h105l-77 -123h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A0301.case",
    horizAdvX: 0,
    d: "M360 834q-44 0 -80 20.5t-57.5 56t-21.5 79.5t21.5 79.5t57.5 56t80 20.5t80 -20.5t57.5 -56t21.5 -79.5t-21.5 -79.5t-57.5 -56t-80 -20.5zM360 906q34 0 59 25t25 59t-25 59t-59 25t-59 -25t-25 -59t25 -59t59 -25zM324 1194l56 123h105l-77 -123h-84z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030A.case",
    horizAdvX: 0,
    d: "M360 834q-44 0 -80 20.5t-57.5 56t-21.5 79.5t21.5 79.5t57.5 56t80 20.5t80 -20.5t57.5 -56t21.5 -79.5t-21.5 -79.5t-57.5 -56t-80 -20.5zM360 906q34 0 59 25t25 59t-25 59t-59 25t-59 -25t-25 -59t25 -59t59 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0335.case",
    horizAdvX: 0,
    d: "M30 258v84h480v-84h-480z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03030304",
    horizAdvX: 0,
    d: "M194 698l-29 82q19 36 47 54.5t63 18.5q31 0 58.5 -12t54 -24.5t52.5 -12.5q30 0 51.5 18.5t34.5 50.5l29 -82q-18 -36 -46 -54.5t-64 -18.5q-30 0 -58 12t-54 24t-52 12q-59 0 -87 -68zM189 921v78h342v-78h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tildecomb.case",
    horizAdvX: 0,
    d: "M163 993l-23 96q23 38 53.5 57t67.5 19q39 0 71.5 -18.5t63.5 -37t63 -18.5t56.5 20t41.5 56l23 -96q-22 -37 -52.5 -56.5t-68.5 -19.5q-39 0 -71.5 18.5t-63 37t-63.5 18.5q-32 0 -56.5 -20t-41.5 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0308.narrow",
    horizAdvX: 0,
    d: "M264 711q-19 0 -33 9.5t-22 25t-8 34.5q0 20 8 35.5t22 24.5t33 9q20 0 34 -9t21.5 -24.5t7.5 -35.5q0 -19 -7.5 -34.5t-21.5 -25t-34 -9.5zM456 711q-19 0 -33 9.5t-22 25t-8 34.5q0 20 8 35.5t22 24.5t33 9q20 0 34 -9t21.5 -24.5t7.5 -35.5q0 -19 -7.5 -34.5 t-21.5 -25t-34 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gravecomb.narrow",
    horizAdvX: 0,
    d: "M377 690l-85 180h126l50 -180h-91z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acutecomb.narrow",
    horizAdvX: 0,
    d: "M252 690l60 180h126l-95 -180h-91z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\"",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "'",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EB6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EB4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EB2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EB0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EAE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EAC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EAA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EA8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EA6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EA4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EA2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u1EA0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0202",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0200",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u01FC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u01FA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0102",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0100",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    g2: "zero.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    g2: "zero.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EEE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EEC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EEA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EE8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EE6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u1EE4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0216",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0214",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u01AF",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0172",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0170",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u016E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u016C",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u016A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\u0168",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xDA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "\xD9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "U",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "el.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EB0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EAA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u1EA0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0202",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0200",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u01FC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u01FA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0104",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0102",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u0100",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xC0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u2026",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\u201A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ".",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: ",",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u2026",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201E",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u201A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ".",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: ",",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "uni004A0301",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u2026",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u201A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EB4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EB2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EB0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EAE",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EAC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EAA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EA8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EA6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EA4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EA2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u1EA0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0202",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0200",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FC",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u01FA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u017B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0179",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0134",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0104",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0102",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0100",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC5",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xC0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "Z",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "J",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ".",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: ",",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0211",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u2026",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: "\u201A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ".",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "U",
    u2: ",",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "_",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "r",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAA",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBA",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u1EF2",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0232",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0178",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0176",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0166",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0164",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\u0162",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "\xDD",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "Y",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE4",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u0166",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u0164",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "\u0162",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEC",
    u2: "T",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0166",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0164",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "\u0162",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEF",
    u2: "T",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF1",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    g2: "ordfeminine.ss02",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1EF2",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1E84",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1E82",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u1E80",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0232",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0178",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0176",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0174",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0166",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0164",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\u0162",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xDD",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xBA",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xB0",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\xAA",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "Y",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "W",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "V",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "T",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "'",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "\"",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0161",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0148",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u010D",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0125",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0125",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0127",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0166",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0164",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u0162",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "T",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u0166",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u0164",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "\u0162",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012D",
    u2: "T",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0161",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0148",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u010D",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0144",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0146",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0148",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0155",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0157",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0159",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u0211",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\u0159",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u0211",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\u0159",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u017E",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u017C",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "\u017A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0165",
    u2: "z",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0211",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0159",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01EA",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0200",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0202",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020C",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u020E",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0211",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0213",
    u2: "T",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\u0211",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\u0159",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022A",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u022C",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0230",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0232",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0232",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA0",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA2",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA4",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA6",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EA8",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAA",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAC",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EAE",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB0",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB2",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB4",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB6",
    u2: "*",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECE",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED0",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED2",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED4",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED6",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ED8",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF4",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF4",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF6",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xF6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xE4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2010",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2018",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xF6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\xE4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    g2: "zero.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201C",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xF6",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE5",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\xE4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    g2: "zero.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    g2: "zero.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aacute.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aacute.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "abreve.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "abreve.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAF.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAF.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB7.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB7.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB1.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB1.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB3.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB3.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB5.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EB5.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "acircumflex.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "acircumflex.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA5.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA5.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAD.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAD.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA7.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA7.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA9.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA9.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAB.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EAB.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0201.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0201.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "adieresis.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "adieresis.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA1.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA1.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "agrave.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "agrave.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA3.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni1EA3.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0203.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0203.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "amacron.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "amacron.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aogonek.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aring.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aring.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aringacute.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "aringacute.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "atilde.ss02",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "atilde.ss02",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine.ss02",
    u2: "\xF6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine.ss02",
    u2: "\xE5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine.ss02",
    u2: "\xE4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "?",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: ")",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_h",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f_h",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_h",
    u2: "\xB3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_h",
    u2: ")",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    u2: "\u2026",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    u2: "\u201E",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    u2: "\u201A",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    u2: ".",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf",
    u2: ",",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.zero.ss01",
    g2: "nine.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.zero.ss01",
    g2: "seven.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.zero.ss01",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.zero.ss01",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.zero.ss01",
    g2: "two.lf",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "dek.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "zero.lf.zero.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    g2: "zero.lf.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1EE2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1EE0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1EDE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1EDC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1EDA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ED8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ED6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ED4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ED2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ED0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ECE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u1ECC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0230",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u022C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u022A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u020E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u020C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u01FE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u01EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u01E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u01E4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u01A0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0150",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u014E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u014C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0120",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u011E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u011C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u010C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u010A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0108",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\u0106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lf",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "one.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.lf",
    g2: "el.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "nine.lf",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "el.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "zero.lf.zero.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    g2: "zero.lf.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1EE2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1EE0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1EDE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1EDC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1EDA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ED8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ED6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ED4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ED2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ED0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ECE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u1ECC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0230",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u022C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u022A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u020E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u020C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u01FE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u01EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u01E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u01E4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u01A0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0150",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u014E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u014C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0120",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u011E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u011C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u010C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u010A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0108",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\u0106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.lf",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "seven.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "el.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "nine.lf",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.lf",
    g2: "one.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "nine.lf",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "seven.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lf",
    g2: "one.lf",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "eight.lf",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "six.lf",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "four.lf",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "one.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "zero.lf.zero.ss01",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "zero.lf.ss01",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    g2: "el.lf",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1EE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1EE0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1EDE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1EDC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1EDA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ED8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ED6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ED4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ED2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ED0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ECE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u1ECC",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0230",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u022C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u022A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u020E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u020C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u01FE",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u01EA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u01E6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u01E4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u01A0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u018F",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0150",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u014E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u014C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0122",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0120",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u011E",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u011C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u010C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u010A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0108",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\u0106",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD5",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD3",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xD2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "\xC7",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "Q",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "O",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "G",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lf",
    u2: "C",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "nine.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "el.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "seven.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.lf",
    g2: "two.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "eight.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "six.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "five.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "four.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "el.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "dek.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "three.lf",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "zero.lf.zero.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    g2: "zero.lf.ss01",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1EE2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1EE0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1EDE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1EDC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1EDA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ED8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ED6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ED4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ED2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ED0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ECE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u1ECC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0230",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u022C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u022A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u020E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u020C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u01FE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u01EA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u01E6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u01E4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u01A0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0150",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u014E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u014C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0120",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u011E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u011C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u010C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u010A",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0108",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\u0106",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xD2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "\xC7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "Q",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "O",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "G",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lf",
    u2: "C",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dek.lf",
    g2: "el.lf",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dek.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dek.lf",
    g2: "two.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dek.lf",
    g2: "one.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "el.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "dek.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "nine.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "eight.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "six.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "five.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "four.lf",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "el.lf",
    g2: "three.lf",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "threequarteremdash",
    u2: "4",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "quotedbl,quotesingle,degree",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "quoteleft,quotedblleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hcircumflex,hbar,nacute,uni0146,ncaron,eng,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02,f_f_h,f_h",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "quotedbl,quotesingle,degree",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "quoteleft,quotedblleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,uni01EB,oslashacute,uni020D,uni020F,uni022B,uni022D,uni0231,uni0259,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,f_f_b,f_b",
    g2: "x",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "J,Jcircumflex,uni004A0301",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "quotedbl,quotesingle,degree",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "quoteleft,quotedblleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,uni018F,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "asterisk,registered,trademark",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quotedbl,quotesingle,degree",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quoteleft,quotedblleft",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "quoteright,quotedblright",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "quotedbl,quotesingle,degree",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0201,uni0203,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7",
    g2: "uni01EF,uni0292",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,ij,jcircumflex,uni01C9,uni01CB,uni01CC,uni0209,uni020B,uni1EC9,uni1ECB,i.loclTRK,uni006A0301,f_f_i,f_f_j",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "J,Jcircumflex,uni004A0301",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "quotedbl,quotesingle,degree",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "quoteleft,quotedblleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,uni0205,uni0207,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7",
    g2: "x",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,uni0204,uni0206,uni1EB8,uni1EBA,uni1EBC,uni1EBE,uni1EC0,uni1EC2,uni1EC4,uni1EC6",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni01C7,uni01CA,uni0214,uni0216,uni1EE4,uni1EE6,uni004A0301",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni01C7,uni01CA,uni0214,uni0216,uni1EE4,uni1EE6,uni004A0301",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,U,Ugrave,Uacute,Ucircumflex,Udieresis,IJ,Jcircumflex,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,uni01C7,uni01CA,uni0214,uni0216,uni1EE4,uni1EE6,uni004A0301",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0215,uni0217,uni0237,pi,uni1EE5,uni1EE7,fi,f_j",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0215,uni0217,uni0237,pi,uni1EE5,uni1EE7,fi,f_j",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0215,uni0217,uni0237,pi,uni1EE5,uni1EE7,fi,f_j",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0215,uni0217,uni0237,pi,uni1EE5,uni1EE7,fi,f_j",
    g2: "quotedbl,quotesingle,degree",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,dotlessi,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0215,uni0217,uni0237,pi,uni1EE5,uni1EE7,fi,f_j",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "J,Jcircumflex,uni004A0301",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "J,Jcircumflex,uni004A0301",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "X",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "J,Jcircumflex,uni004A0301",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "J,Jcircumflex,uni004A0301",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "partialdiff",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "quotedbl,quotesingle,degree",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "colon,semicolon",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    g2: "x",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122,uni01E4,Gcaron",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122,uni01E4,Gcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122,uni01E4,Gcaron",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,uni0122,uni01E4,Gcaron",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "quotedbl,quotesingle,degree",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "quoteleft,quotedblleft",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "quoteright,quotedblright",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,uni013B,Lcaron,Ldot,Lslash,uni01C8",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "quotedbl,quotesingle,degree",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,uni0123,uni01E5,gcaron",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "quotedbl,quotesingle,degree",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "quoteleft,quotedblleft",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6",
    g2: "partialdiff",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "b,h,k,l,thorn,hcircumflex,hbar,lcaron,ldot,uni01C9,uni01E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "partialdiff",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "quotedbl,quotesingle,degree",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,uni0156,Rcaron,uni0210,uni0212",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "quotedbl,quotesingle,degree",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "partialdiff",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "uni01EF,uni0292",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "uni0259",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Uhorn,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    g2: "x",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex,uni004A0301",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "partialdiff",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quotedbl,quotesingle,degree",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "partialdiff",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle,degree",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "l.ss03,lacute.ss03,lcaron.ss03,uni013C.ss03,ldot.ss03",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "partialdiff",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "quotedbl,quotesingle,degree",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "quoteleft,quotedblleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,x,kgreenlandic,uni01E9,f_f_k,f_k",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.ss03,lacute.ss03,lcaron.ss03,uni013C.ss03,f_f_l.ss03,fl.ss03",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ohorn,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ohorn,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    g2: "partialdiff",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "J,Jcircumflex,uni004A0301",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "partialdiff",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "quotedbl,quotesingle,degree",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,uni0157,rcaron,uni0211,uni0213",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "quotedbl,quotesingle,degree",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    g2: "x",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uhorn,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uhorn,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    g2: "partialdiff",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "partialdiff",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "J,Jcircumflex,uni004A0301",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "partialdiff",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quotedbl,quotesingle,degree",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "colon,semicolon",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quoteleft,quotedblleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A",
    g2: "x",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "J,Jcircumflex,uni004A0301",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,uni021B,f_t,t_t",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Uhorn,uni0214,uni0216,uni1EE4,uni1EE6,uni1EE8,uni1EEA,uni1EEC,uni1EEE,uni1EF0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "b,h,k,l,thorn,hcircumflex,hbar,lcaron,ldot,uni01C9,uni01E9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "J,Jcircumflex,uni004A0301",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "quotedbl,quotesingle,degree",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "quoteleft,quotedblleft",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "quoteright,quotedblright",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,X,uni0136,uni01E8",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk,registered,trademark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,l,dcroat",
    g2: "quoteright,quotedblright",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "J,Jcircumflex,uni004A0301",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "J,Jcircumflex,uni004A0301",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "partialdiff",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ordfeminine,ordmasculine,ordfeminine.ss02",
    g2: "X",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "partialdiff",
    k: 180
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "dcaron,lcaron",
    g2: "colon,semicolon",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni01EF,uni0292",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni01EF,uni0292",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex,uni004A0301",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk,registered,trademark",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "partialdiff",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quotedbl,quotesingle,degree",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bracketright,braceright",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteleft,quotedblleft",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteright,quotedblright",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "f,fi,fl,f_f,f_f_b,f_f_h,f_f_i,f_f_j,f_f_k,f_f_l,f_f_l.ss03,f_b,f_h,f_j,f_k,fl.ss03,f_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "x",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "b,h,k,l,thorn,hcircumflex,hbar,lcaron,ldot,uni01C9,uni01E9",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex,uni004A0301",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "X",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,uni0122,Omacron,Obreve,Ohungarumlaut,uni018F,Ohorn,uni01E4,Gcaron,uni01EA,Oslashacute,uni020C,uni020E,uni022A,uni022C,uni0230,uni1ECC,uni1ECE,uni1ED0,uni1ED2,uni1ED4,uni1ED6,uni1ED8,uni1EDA,uni1EDC,uni1EDE,uni1EE0,uni1EE2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex,uni004A0301",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "x",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,uni0218",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "J,Jcircumflex,uni004A0301",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "X",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "quotedbl,quotesingle,degree",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,uhorn,uni0215,uni0217,uni1EE5,uni1EE7,uni1EE9,uni1EEB,uni1EED,uni1EEF,uni1EF1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex,uni004A0301",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "partialdiff",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "quotedbl,quotesingle,degree",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "x",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,AE,Amacron,Abreve,Aogonek,Aringacute,AEacute,uni0200,uni0202,uni1EA0,uni1EA2,uni1EA4,uni1EA6,uni1EA8,uni1EAA,uni1EAC,uni1EAE,uni1EB0,uni1EB2,uni1EB4,uni1EB6",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ae,aeacute,a.ss02,aacute.ss02,abreve.ss02,uni1EAF.ss02,uni1EB7.ss02,uni1EB1.ss02,uni1EB3.ss02,uni1EB5.ss02,acircumflex.ss02,uni1EA5.ss02,uni1EAD.ss02,uni1EA7.ss02,uni1EA9.ss02,uni1EAB.ss02,uni0201.ss02,adieresis.ss02,uni1EA1.ss02,agrave.ss02,uni1EA3.ss02,uni0203.ss02,amacron.ss02,aogonek.ss02,aring.ss02,aringacute.ss02,atilde.ss02",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex,uni004A0301",
    k: 150
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "partialdiff",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "quotedbl,quotesingle,degree",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "ordfeminine,ordmasculine,ordfeminine.ss02",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "lslash",
    g2: "v,w,y,yacute,ydieresis,wcircumflex,ycircumflex,uni0233,wgrave,wacute,wdieresis,ygrave,uni1EF5,uni1EF7,uni1EF9",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni0232,Ygrave,uni1EF4,uni1EF6,uni1EF8",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q",
    g2: "V,W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q",
    g2: "T,uni0162,Tcaron,Tbar,uni021A",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "a,c,d,e,g,o,q,agrave,aacute,acircumflex,atilde,adieresis,aring,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,amacron,abreve,aogonek,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,emacron,ebreve,edotaccent,eogonek,ecaron,gcircumflex,gbreve,gdotaccent,uni0123,omacron,obreve,ohungarumlaut,oe,ohorn,uni01C6,uni01E5,gcaron,uni01EB,aringacute,oslashacute,uni0201,uni0203,uni0205,uni0207,uni020D,uni020F,uni022B,uni022D,uni0231,uni1EA1,uni1EA3,uni1EA5,uni1EA7,uni1EA9,uni1EAB,uni1EAD,uni1EAF,uni1EB1,uni1EB3,uni1EB5,uni1EB7,uni1EB9,uni1EBB,uni1EBD,uni1EBF,uni1EC1,uni1EC3,uni1EC5,uni1EC7,uni1ECD,uni1ECF,uni1ED1,uni1ED3,uni1ED5,uni1ED7,uni1ED9,uni1EDB,uni1EDD,uni1EDF,uni1EE1,uni1EE3",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "m,n,p,r,ntilde,dotlessi,kgreenlandic,nacute,uni0146,ncaron,eng,racute,uni0157,rcaron,uni01CC,uni0211,uni0213,uni0237,pi",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "s,sacute,scircumflex,scedilla,scaron,uni0219",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "t,uni0163,tcaron,uni021B,t_t",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "tcaron",
    g2: "partialdiff",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "plus,asciitilde,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    g2: "partialdiff",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "partialdiff",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle,degree",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "hyphen,underscore,guillemotleft,guillemotright,uni2010,endash,emdash,guilsinglleft,guilsinglright,threequarteremdash",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "quotedbl,quotesingle,degree",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "quoteleft,quotedblleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "partialdiff",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "partialdiff",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "partialdiff",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "zero.lf.ss01,zero.lf.zero.ss01",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "plus,asciitilde,logicalnot,divide,minus,hyphen.case,endash.case,threequarteremdash.case,emdash.case,uni2010.case,guillemotleft.case,guillemotright.case,guilsinglleft.case,guilsinglright.case",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "quotedbl,quotesingle,degree",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lf.ss01,zero.lf.zero.ss01",
    g2: "quoteleft,quotedblleft",
    k: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.f6281418886fe75b8be2db4b739bd0ca.svg";
export { ForwardRef as ReactComponent };